/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v12.2.5.0 (NJsonSchema v9.13.37.0 (Newtonsoft.Json v9.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export class ConnectClient {
    public transformOptions: (opts: any) => Promise<any> = opts => Promise.resolve(opts);
private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    token(model: GenerateTokenModel): Promise<TokenResponse> {
        let url_ = this.baseUrl + "/api/Connect/Token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processToken(_response);
        });
    }

    protected processToken(response: Response): Promise<TokenResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <TokenResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TokenResponse>(<any>null);
    }

    dummyMethodRequiringAuthentication(): Promise<string> {
        let url_ = this.baseUrl + "/api/Connect/DummyMethodRequiringAuthentication";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDummyMethodRequiringAuthentication(_response);
        });
    }

    protected processDummyMethodRequiringAuthentication(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }
}

export class DataClient {
    public transformOptions: (opts: any) => Promise<any> = opts => Promise.resolve(opts);
private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getAllProjects(statusTypeId: number, createdById: string | null): Promise<ProjectListResponse> {
        let url_ = this.baseUrl + "/dataapi/getAllProjects/{statusTypeId}/{createdById}";
        if (statusTypeId === undefined || statusTypeId === null)
            throw new Error("The parameter 'statusTypeId' must be defined.");
        url_ = url_.replace("{statusTypeId}", encodeURIComponent("" + statusTypeId)); 
        if (createdById === undefined || createdById === null)
            throw new Error("The parameter 'createdById' must be defined.");
        url_ = url_.replace("{createdById}", encodeURIComponent("" + createdById)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllProjects(_response);
        });
    }

    protected processGetAllProjects(response: Response): Promise<ProjectListResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProjectListResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectListResponse>(<any>null);
    }

    getProjectsBySearchText(statusTypeId: number, createdById: string | null, searchText: string | null): Promise<ProjectListResponse> {
        let url_ = this.baseUrl + "/dataapi/getProjectsBySearchText/{statusTypeId}/{createdById}/{searchText}";
        if (statusTypeId === undefined || statusTypeId === null)
            throw new Error("The parameter 'statusTypeId' must be defined.");
        url_ = url_.replace("{statusTypeId}", encodeURIComponent("" + statusTypeId)); 
        if (createdById === undefined || createdById === null)
            throw new Error("The parameter 'createdById' must be defined.");
        url_ = url_.replace("{createdById}", encodeURIComponent("" + createdById)); 
        if (searchText === undefined || searchText === null)
            throw new Error("The parameter 'searchText' must be defined.");
        url_ = url_.replace("{searchText}", encodeURIComponent("" + searchText)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProjectsBySearchText(_response);
        });
    }

    protected processGetProjectsBySearchText(response: Response): Promise<ProjectListResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProjectListResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectListResponse>(<any>null);
    }

    getProjectByProjectId(projectId: string | null): Promise<ProjectListResponse> {
        let url_ = this.baseUrl + "/dataapi/getProjectByProjectId/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProjectByProjectId(_response);
        });
    }

    protected processGetProjectByProjectId(response: Response): Promise<ProjectListResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProjectListResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectListResponse>(<any>null);
    }

    getEnumValues(enumID: number): Promise<EnumListResponse> {
        let url_ = this.baseUrl + "/dataapi/getEnumValues/{enumID}";
        if (enumID === undefined || enumID === null)
            throw new Error("The parameter 'enumID' must be defined.");
        url_ = url_.replace("{enumID}", encodeURIComponent("" + enumID)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEnumValues(_response);
        });
    }

    protected processGetEnumValues(response: Response): Promise<EnumListResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <EnumListResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnumListResponse>(<any>null);
    }

    // updateProject(request: ProjectRequest): Promise<ProjectResponse> {
    //     let url_ = this.baseUrl + "/dataapi/updateProject";
    //     url_ = url_.replace(/[?&]$/, "");

    //     const content_ = JSON.stringify(request);

    //     let options_ = <RequestInit>{
    //         body: content_,
    //         method: "POST",
    //         headers: {
    //             "Content-Type": "application/json", 
    //             "Accept": "application/json"
    //         }
    //     };

    //     return this.transformOptions(options_).then(transformedOptions_ => {
    //         return this.http.fetch(url_, transformedOptions_);
    //     }).then((_response: Response) => {
    //         return this.processUpdateProject(_response);
    //     });
    // }

    protected processUpdateProject(response: Response): Promise<ProjectResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProjectResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectResponse>(<any>null);
    }

    addNewProject(request: ProjectRequest): Promise<ProjectResponse> {
        let url_ = this.baseUrl + "/dataapi/addNewProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddNewProject(_response);
        });
    }

    protected processAddNewProject(response: Response): Promise<ProjectResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProjectResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectResponse>(<any>null);
    }

    addNewUnit(unit: UnitDTO): Promise<UnitResponse> {
        let url_ = this.baseUrl + "/dataapi/addNewUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(unit);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddNewUnit(_response);
        });
    }

    protected processAddNewUnit(response: Response): Promise<UnitResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <UnitResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitResponse>(<any>null);
    }

    getUnits(projectId: number): Promise<UnitListResponse> {
        let url_ = this.baseUrl + "/dataapi/getUnits/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUnits(_response);
        });
    }

    protected processGetUnits(response: Response): Promise<UnitListResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <UnitListResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitListResponse>(<any>null);
    }

    getUnitsForOutputDocUI(projectId: number): Promise<UnitOutputDocListResponse> {
        let url_ = this.baseUrl + "/dataapi/getUnitsForOutputDocUI/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUnitsForOutputDocUI(_response);
        });
    }

    protected processGetUnitsForOutputDocUI(response: Response): Promise<UnitOutputDocListResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <UnitOutputDocListResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitOutputDocListResponse>(<any>null);
    }

    getUnit(unitId: number): Promise<UnitResponse> {
        let url_ = this.baseUrl + "/dataapi/getUnit/{unitId}";
        if (unitId === undefined || unitId === null)
            throw new Error("The parameter 'unitId' must be defined.");
        url_ = url_.replace("{unitId}", encodeURIComponent("" + unitId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUnit(_response);
        });
    }

    protected processGetUnit(response: Response): Promise<UnitResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <UnitResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitResponse>(<any>null);
    }

    deleteProject(request: DeleteProjectRequest): Promise<StandardResponse> {
        let url_ = this.baseUrl + "/dataapi/deleteProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteProject(_response);
        });
    }

    protected processDeleteProject(response: Response): Promise<StandardResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <StandardResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StandardResponse>(<any>null);
    }

    copyUnit(request: CopyUnitRequest): Promise<StandardResponse> {
        let url_ = this.baseUrl + "/dataapi/copyUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCopyUnit(_response);
        });
    }

    protected processCopyUnit(response: Response): Promise<StandardResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <StandardResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StandardResponse>(<any>null);
    }

    copyProject(request: CopyProjectRequest): Promise<StandardResponse> {
        let url_ = this.baseUrl + "/dataapi/copyProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCopyProject(_response);
        });
    }

    protected processCopyProject(response: Response): Promise<StandardResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <StandardResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StandardResponse>(<any>null);
    }

    // getProjectAndUnitName(projectId: number, unitId: number): Promise<ProjectAndUnitNameResponse> {
    //     let url_ = this.baseUrl + "/dataapi/getProjectAndUnitName/{projectId}/{unitId}";
    //     if (projectId === undefined || projectId === null)
    //         throw new Error("The parameter 'projectId' must be defined.");
    //     url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
    //     if (unitId === undefined || unitId === null)
    //         throw new Error("The parameter 'unitId' must be defined.");
    //     url_ = url_.replace("{unitId}", encodeURIComponent("" + unitId)); 
    //     url_ = url_.replace(/[?&]$/, "");

    //     let options_ = <RequestInit>{
    //         method: "GET",
    //         headers: {
    //             "Accept": "application/json"
    //         }
    //     };

    //     return this.transformOptions(options_).then(transformedOptions_ => {
    //         return this.http.fetch(url_, transformedOptions_);
    //     }).then((_response: Response) => {
    //         return this.processGetProjectAndUnitName(_response);
    //     });
    // }

    protected processGetProjectAndUnitName(response: Response): Promise<ProjectAndUnitNameResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProjectAndUnitNameResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectAndUnitNameResponse>(<any>null);
    }

    getFanCurveChart(projectId: string | null, unitId: number, selectedFan: string | null): Promise<FileResponse> {
        let url_ = this.baseUrl + "/dataapi/getFanCurveChart/{projectId}/{unitId}/{selectedFan}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        if (unitId === undefined || unitId === null)
            throw new Error("The parameter 'unitId' must be defined.");
        url_ = url_.replace("{unitId}", encodeURIComponent("" + unitId)); 
        if (selectedFan === undefined || selectedFan === null)
            throw new Error("The parameter 'selectedFan' must be defined.");
        url_ = url_.replace("{selectedFan}", encodeURIComponent("" + selectedFan)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFanCurveChart(_response);
        });
    }

    protected processGetFanCurveChart(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    getUnitDrawingFromService(projectId: number, unitId: number, viewType: number, uiScreen: number): Promise<UnitDrawingResponse> {
        let url_ = this.baseUrl + "/dataapi/getUnitDrawingFromService/{projectId}/{unitId}/{viewType}/{uiScreen}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        if (unitId === undefined || unitId === null)
            throw new Error("The parameter 'unitId' must be defined.");
        url_ = url_.replace("{unitId}", encodeURIComponent("" + unitId)); 
        if (viewType === undefined || viewType === null)
            throw new Error("The parameter 'viewType' must be defined.");
        url_ = url_.replace("{viewType}", encodeURIComponent("" + viewType)); 
        if (uiScreen === undefined || uiScreen === null)
            throw new Error("The parameter 'uiScreen' must be defined.");
        url_ = url_.replace("{uiScreen}", encodeURIComponent("" + uiScreen)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUnitDrawingFromService(_response);
        });
    }

    protected processGetUnitDrawingFromService(response: Response): Promise<UnitDrawingResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <UnitDrawingResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitDrawingResponse>(<any>null);
    }

    getFanSoundData(projectId: string | null, unitId: number, selectedFan: string | null): Promise<UnitFanResponse> {
        let url_ = this.baseUrl + "/dataapi/getFanSoundData/{projectId}/{unitId}/{selectedFan}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        if (unitId === undefined || unitId === null)
            throw new Error("The parameter 'unitId' must be defined.");
        url_ = url_.replace("{unitId}", encodeURIComponent("" + unitId)); 
        if (selectedFan === undefined || selectedFan === null)
            throw new Error("The parameter 'selectedFan' must be defined.");
        url_ = url_.replace("{selectedFan}", encodeURIComponent("" + selectedFan)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFanSoundData(_response);
        });
    }

    protected processGetFanSoundData(response: Response): Promise<UnitFanResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <UnitFanResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitFanResponse>(<any>null);
    }

    getLowryProgramVersion(): Promise<ApplicationDataResponse> {
        let url_ = this.baseUrl + "/dataapi/getLowryProgramVersion";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLowryProgramVersion(_response);
        });
    }

    protected processGetLowryProgramVersion(response: Response): Promise<ApplicationDataResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApplicationDataResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicationDataResponse>(<any>null);
    }

    sendSupportEmail(request: ContactUsEmailRequest): Promise<StandardResponse> {
        let url_ = this.baseUrl + "/dataapi/sendSupportEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendSupportEmail(_response);
        });
    }

    protected processSendSupportEmail(response: Response): Promise<StandardResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <StandardResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StandardResponse>(<any>null);
    }

    generateSpecMateDocuments(request: SpecMateDocumentsRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/dataapi/generatespecmatedocuments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGenerateSpecMateDocuments(_response);
        });
    }

    protected processGenerateSpecMateDocuments(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    generateJobPriceSummary(request: PDFRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/dataapi/generatejobpricesummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGenerateJobPriceSummary(_response);
        });
    }

    protected processGenerateJobPriceSummary(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    addPdfProcessingRequest(pdfProcessingRequest: PdfProcessingRequest): Promise<StandardResponse> {
        let url_ = this.baseUrl + "/dataapi/addPdfProcessingRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pdfProcessingRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddPdfProcessingRequest(_response);
        });
    }

    protected processAddPdfProcessingRequest(response: Response): Promise<StandardResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <StandardResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StandardResponse>(<any>null);
    }

    getPdfProcessingRecords(projectId: number): Promise<PdfProcessingResponse> {
        let url_ = this.baseUrl + "/dataapi/getPdfProcessingRecords/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPdfProcessingRecords(_response);
        });
    }

    protected processGetPdfProcessingRecords(response: Response): Promise<PdfProcessingResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PdfProcessingResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PdfProcessingResponse>(<any>null);
    }
}

export class PingClient {
    public transformOptions: (opts: any) => Promise<any> = opts => Promise.resolve(opts);
private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    index(): Promise<string> {
        let url_ = this.baseUrl + "/api/Ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIndex(_response);
        });
    }

    protected processIndex(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }
}

export class ProjectClient {
    public transformOptions: (opts: any) => Promise<any> = opts => Promise.resolve(opts);
private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getString(projectId: string): Promise<string> {
        let url_ = this.baseUrl + "/api/Project/{projectId}/getString";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetString(_response);
        });
    }

    protected processGetString(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    index(projectId: string | null): Promise<ProjectData> {
        let url_ = this.baseUrl + "/api/Project/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIndex(_response);
        });
    }

    protected processIndex(response: Response): Promise<ProjectData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProjectData>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <ApiError>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectData>(<any>null);
    }

    debugJson(projectId: string | null): Promise<string> {
        let url_ = this.baseUrl + "/api/Project/{projectId}/DebugJson";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDebugJson(_response);
        });
    }

    protected processDebugJson(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    updateUnitDesign(projectId: string | null, unitId: number): Promise<StandardResponse> {
        let url_ = this.baseUrl + "/api/Project/{projectId}/UpdateUnitDesign";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(unitId);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateUnitDesign(_response);
        });
    }

    protected processUpdateUnitDesign(response: Response): Promise<StandardResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <StandardResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StandardResponse>(<any>null);
    }

    updateMultipleUnits(projectId: string | null, unitIds: number[]): Promise<StandardResponse> {
        let url_ = this.baseUrl + "/api/Project/{projectId}/UpdateMultipleUnits";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(unitIds);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateMultipleUnits(_response);
        });
    }

    protected processUpdateMultipleUnits(response: Response): Promise<StandardResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <StandardResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StandardResponse>(<any>null);
    }

    modifyProperty(projectId: string | null, propertyModification: PropertyModification): Promise<void> {
        let url_ = this.baseUrl + "/api/Project/{projectId}/ModifyProperty";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(propertyModification);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processModifyProperty(_response);
        });
    }

    protected processModifyProperty(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiError>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <ApiError>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    deleteProperty(projectId: string | null, propertyDeletion: PropertyDeletion): Promise<void> {
        let url_ = this.baseUrl + "/api/Project/{projectId}/DeleteProperty";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(propertyDeletion);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteProperty(_response);
        });
    }

    protected processDeleteProperty(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiError>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <ApiError>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    modifySelectedModelProperty(projectId: string | null, propertyModification: PropertyModification): Promise<ModifySelectedModelResult> {
        let url_ = this.baseUrl + "/api/Project/{projectId}/ModifySelectedModelProperty";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(propertyModification);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processModifySelectedModelProperty(_response);
        });
    }

    protected processModifySelectedModelProperty(response: Response): Promise<ModifySelectedModelResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ModifySelectedModelResult>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <ApiError>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModifySelectedModelResult>(<any>null);
    }

    modifyCasingSizeLimitProperty(projectId: string | null, propertyModification: PropertyModification): Promise<ModifyCasingSizeLimitResult> {
        let url_ = this.baseUrl + "/api/Project/{projectId}/ModifyCasingSizeLimitProperty";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(propertyModification);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processModifyCasingSizeLimitProperty(_response);
        });
    }

    protected processModifyCasingSizeLimitProperty(response: Response): Promise<ModifyCasingSizeLimitResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ModifyCasingSizeLimitResult>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiError>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <ApiError>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModifyCasingSizeLimitResult>(<any>null);
    }

    getUnitDrawingSvg(projectId: string | null, unitId: number | undefined, viewType: number | undefined, uiScreen: DrawingScreen | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Project/{projectId}/GetUnitDrawingSvg?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        if (unitId === null)
            throw new Error("The parameter 'unitId' cannot be null.");
        else if (unitId !== undefined)
            url_ += "unitId=" + encodeURIComponent("" + unitId) + "&"; 
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&"; 
        if (uiScreen === null)
            throw new Error("The parameter 'uiScreen' cannot be null.");
        else if (uiScreen !== undefined)
            url_ += "uiScreen=" + encodeURIComponent("" + uiScreen) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUnitDrawingSvg(_response);
        });
    }

    protected processGetUnitDrawingSvg(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    getInletOutletDrawingSvg(projectId: string | null, unitId: number | undefined, selectedConnection: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Project/{projectId}/GetInletOutletDrawingSvg?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        if (unitId === null)
            throw new Error("The parameter 'unitId' cannot be null.");
        else if (unitId !== undefined)
            url_ += "unitId=" + encodeURIComponent("" + unitId) + "&"; 
        if (selectedConnection !== undefined)
            url_ += "selectedConnection=" + encodeURIComponent("" + selectedConnection) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInletOutletDrawingSvg(_response);
        });
    }

    protected processGetInletOutletDrawingSvg(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    deleteUnit(projectId: string | null, unitId: number): Promise<StandardResponse> {
        let url_ = this.baseUrl + "/api/Project/{projectId}/DeleteUnit";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(unitId);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteUnit(_response);
        });
    }

    protected processDeleteUnit(response: Response): Promise<StandardResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <StandardResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StandardResponse>(<any>null);
    }

    deleteProject(projectId: string | null): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Project/{projectId}/DeleteProject";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteProject(_response);
        });
    }

    protected processDeleteProject(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    runPerformanceCalculations(projectId: string | null, unitId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Project/{projectId}/RunPerformanceCalculations";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(unitId);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRunPerformanceCalculations(_response);
        });
    }

    protected processRunPerformanceCalculations(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    getTunnelSizingLog(projectId: string | null, unitId: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Project/{projectId}/GetTunnelSizingLog?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        if (unitId === null)
            throw new Error("The parameter 'unitId' cannot be null.");
        else if (unitId !== undefined)
            url_ += "unitId=" + encodeURIComponent("" + unitId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTunnelSizingLog(_response);
        });
    }

    protected processGetTunnelSizingLog(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    getUnitLengthReport(projectId: string | null, unitId: number | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Project/{projectId}/GetUnitLengthReport?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        if (unitId === null)
            throw new Error("The parameter 'unitId' cannot be null.");
        else if (unitId !== undefined)
            url_ += "unitId=" + encodeURIComponent("" + unitId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUnitLengthReport(_response);
        });
    }

    protected processGetUnitLengthReport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    getProjectJson(projectId: string | null): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Project/{projectId}/GetProjectJson";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProjectJson(_response);
        });
    }

    protected processGetProjectJson(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    getConfigurationInputsUI(projectId: string | null, unitId: number | undefined): Promise<ConfigurationInputsUI> {
        let url_ = this.baseUrl + "/api/Project/{projectId}/GetConfigurationInputsUI?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        if (unitId === null)
            throw new Error("The parameter 'unitId' cannot be null.");
        else if (unitId !== undefined)
            url_ += "unitId=" + encodeURIComponent("" + unitId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetConfigurationInputsUI(_response);
        });
    }

    protected processGetConfigurationInputsUI(response: Response): Promise<ConfigurationInputsUI> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ConfigurationInputsUI>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConfigurationInputsUI>(<any>null);
    }

    getConnectionsAndOptionsUI(projectId: string | null, unitId: number | undefined): Promise<ConnectionsAndOptionsUI> {
        let url_ = this.baseUrl + "/api/Project/{projectId}/GetConnectionsAndOptionsUI?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        if (unitId === null)
            throw new Error("The parameter 'unitId' cannot be null.");
        else if (unitId !== undefined)
            url_ += "unitId=" + encodeURIComponent("" + unitId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetConnectionsAndOptionsUI(_response);
        });
    }

    protected processGetConnectionsAndOptionsUI(response: Response): Promise<ConnectionsAndOptionsUI> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ConnectionsAndOptionsUI>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConnectionsAndOptionsUI>(<any>null);
    }

    getTempsAndSystemUI(projectId: string | null, unitId: number | undefined): Promise<TempsAndSystemUI> {
        let url_ = this.baseUrl + "/api/Project/{projectId}/GetTempsAndSystemUI?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        if (unitId === null)
            throw new Error("The parameter 'unitId' cannot be null.");
        else if (unitId !== undefined)
            url_ += "unitId=" + encodeURIComponent("" + unitId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTempsAndSystemUI(_response);
        });
    }

    protected processGetTempsAndSystemUI(response: Response): Promise<TempsAndSystemUI> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <TempsAndSystemUI>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TempsAndSystemUI>(<any>null);
    }

    getPerformanceUI(projectId: string | null, unitId: number | undefined): Promise<UiScreenResultOfPerformanceUI> {
        let url_ = this.baseUrl + "/api/Project/{projectId}/GetPerformanceUI?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        if (unitId === null)
            throw new Error("The parameter 'unitId' cannot be null.");
        else if (unitId !== undefined)
            url_ += "unitId=" + encodeURIComponent("" + unitId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPerformanceUI(_response);
        });
    }

    protected processGetPerformanceUI(response: Response): Promise<UiScreenResultOfPerformanceUI> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <UiScreenResultOfPerformanceUI>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UiScreenResultOfPerformanceUI>(<any>null);
    }

    getOptimizedDesignPerformance(projectId: string | null, unitId: number | undefined): Promise<OptimizedPerformanceResponse> {
        let url_ = this.baseUrl + "/api/Project/{projectId}/GetOptimizedDesignPerformance?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        if (unitId === null)
            throw new Error("The parameter 'unitId' cannot be null.");
        else if (unitId !== undefined)
            url_ += "unitId=" + encodeURIComponent("" + unitId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOptimizedDesignPerformance(_response);
        });
    }

    protected processGetOptimizedDesignPerformance(response: Response): Promise<OptimizedPerformanceResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <OptimizedPerformanceResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OptimizedPerformanceResponse>(<any>null);
    }

    getComponentsUI(projectId: string | null, unitId: number | undefined): Promise<ComponentsUI> {
        let url_ = this.baseUrl + "/api/Project/{projectId}/GetComponentsUI?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        if (unitId === null)
            throw new Error("The parameter 'unitId' cannot be null.");
        else if (unitId !== undefined)
            url_ += "unitId=" + encodeURIComponent("" + unitId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetComponentsUI(_response);
        });
    }

    protected processGetComponentsUI(response: Response): Promise<ComponentsUI> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ComponentsUI>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ComponentsUI>(<any>null);
    }

    getUnitSelectionUI(projectId: string | null, unitId: number | undefined): Promise<UnitSelectionUI> {
        let url_ = this.baseUrl + "/api/Project/{projectId}/GetUnitSelectionUI?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        if (unitId === null)
            throw new Error("The parameter 'unitId' cannot be null.");
        else if (unitId !== undefined)
            url_ += "unitId=" + encodeURIComponent("" + unitId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUnitSelectionUI(_response);
        });
    }

    protected processGetUnitSelectionUI(response: Response): Promise<UnitSelectionUI> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <UnitSelectionUI>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitSelectionUI>(<any>null);
    }

    getAccessEditingAndDrawingUI(projectId: string | null, unitId: number | undefined): Promise<AccessEditingAndDrawingUI> {
        let url_ = this.baseUrl + "/api/Project/{projectId}/GetAccessEditingAndDrawingUI?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        if (unitId === null)
            throw new Error("The parameter 'unitId' cannot be null.");
        else if (unitId !== undefined)
            url_ += "unitId=" + encodeURIComponent("" + unitId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAccessEditingAndDrawingUI(_response);
        });
    }

    protected processGetAccessEditingAndDrawingUI(response: Response): Promise<AccessEditingAndDrawingUI> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AccessEditingAndDrawingUI>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccessEditingAndDrawingUI>(<any>null);
    }

    getAccessDoorsUI(projectId: string | null, unitId: number | undefined): Promise<AccessDoorsUI> {
        let url_ = this.baseUrl + "/api/Project/{projectId}/GetAccessDoorsUI?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        if (unitId === null)
            throw new Error("The parameter 'unitId' cannot be null.");
        else if (unitId !== undefined)
            url_ += "unitId=" + encodeURIComponent("" + unitId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAccessDoorsUI(_response);
        });
    }

    protected processGetAccessDoorsUI(response: Response): Promise<AccessDoorsUI> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AccessDoorsUI>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccessDoorsUI>(<any>null);
    }

    getCoilConnectionsUI(projectId: string | null, unitId: number | undefined): Promise<CoilConnectionsUI> {
        let url_ = this.baseUrl + "/api/Project/{projectId}/GetCoilConnectionsUI?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        if (unitId === null)
            throw new Error("The parameter 'unitId' cannot be null.");
        else if (unitId !== undefined)
            url_ += "unitId=" + encodeURIComponent("" + unitId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCoilConnectionsUI(_response);
        });
    }

    protected processGetCoilConnectionsUI(response: Response): Promise<CoilConnectionsUI> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CoilConnectionsUI>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CoilConnectionsUI>(<any>null);
    }

    getElectFurnacePanelsUI(projectId: string | null, unitId: number | undefined): Promise<ElectFurnacePanelsUI> {
        let url_ = this.baseUrl + "/api/Project/{projectId}/GetElectFurnacePanelsUI?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        if (unitId === null)
            throw new Error("The parameter 'unitId' cannot be null.");
        else if (unitId !== undefined)
            url_ += "unitId=" + encodeURIComponent("" + unitId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetElectFurnacePanelsUI(_response);
        });
    }

    protected processGetElectFurnacePanelsUI(response: Response): Promise<ElectFurnacePanelsUI> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ElectFurnacePanelsUI>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ElectFurnacePanelsUI>(<any>null);
    }

    getLengthInputsUI(projectId: string | null, unitId: number | undefined): Promise<LengthInputsUI> {
        let url_ = this.baseUrl + "/api/Project/{projectId}/GetLengthInputsUI?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        if (unitId === null)
            throw new Error("The parameter 'unitId' cannot be null.");
        else if (unitId !== undefined)
            url_ += "unitId=" + encodeURIComponent("" + unitId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLengthInputsUI(_response);
        });
    }

    protected processGetLengthInputsUI(response: Response): Promise<LengthInputsUI> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <LengthInputsUI>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LengthInputsUI>(<any>null);
    }

    getComponentConstructionUI(projectId: string | null, unitId: number | undefined): Promise<ComponentConstructionUI> {
        let url_ = this.baseUrl + "/api/Project/{projectId}/GetComponentConstructionUI?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        if (unitId === null)
            throw new Error("The parameter 'unitId' cannot be null.");
        else if (unitId !== undefined)
            url_ += "unitId=" + encodeURIComponent("" + unitId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetComponentConstructionUI(_response);
        });
    }

    protected processGetComponentConstructionUI(response: Response): Promise<ComponentConstructionUI> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ComponentConstructionUI>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ComponentConstructionUI>(<any>null);
    }

    getInletOutletSizingUI(projectId: string | null, unitId: number | undefined): Promise<InletOutletSizingUI> {
        let url_ = this.baseUrl + "/api/Project/{projectId}/GetInletOutletSizingUI?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        if (unitId === null)
            throw new Error("The parameter 'unitId' cannot be null.");
        else if (unitId !== undefined)
            url_ += "unitId=" + encodeURIComponent("" + unitId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInletOutletSizingUI(_response);
        });
    }

    protected processGetInletOutletSizingUI(response: Response): Promise<InletOutletSizingUI> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <InletOutletSizingUI>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InletOutletSizingUI>(<any>null);
    }

    getControlsUI(projectId: string | null, unitId: number | undefined): Promise<ControlsUI> {
        let url_ = this.baseUrl + "/api/Project/{projectId}/GetControlsUI?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        if (unitId === null)
            throw new Error("The parameter 'unitId' cannot be null.");
        else if (unitId !== undefined)
            url_ += "unitId=" + encodeURIComponent("" + unitId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetControlsUI(_response);
        });
    }

    protected processGetControlsUI(response: Response): Promise<ControlsUI> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ControlsUI>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ControlsUI>(<any>null);
    }

    getElectricalUI(projectId: string | null, unitId: number | undefined): Promise<ElectricalUI> {
        let url_ = this.baseUrl + "/api/Project/{projectId}/GetElectricalUI?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        if (unitId === null)
            throw new Error("The parameter 'unitId' cannot be null.");
        else if (unitId !== undefined)
            url_ += "unitId=" + encodeURIComponent("" + unitId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetElectricalUI(_response);
        });
    }

    protected processGetElectricalUI(response: Response): Promise<ElectricalUI> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ElectricalUI>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ElectricalUI>(<any>null);
    }

    getUnitCabinetUI(projectId: string | null, unitId: number | undefined): Promise<UnitCabinetUI> {
        let url_ = this.baseUrl + "/api/Project/{projectId}/GetUnitCabinetUI?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        if (unitId === null)
            throw new Error("The parameter 'unitId' cannot be null.");
        else if (unitId !== undefined)
            url_ += "unitId=" + encodeURIComponent("" + unitId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUnitCabinetUI(_response);
        });
    }

    protected processGetUnitCabinetUI(response: Response): Promise<UnitCabinetUI> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <UnitCabinetUI>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitCabinetUI>(<any>null);
    }

    resetToOptimized(projectId: string | null, unitId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Project/{projectId}/ResetToOptimized";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(unitId);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processResetToOptimized(_response);
        });
    }

    protected processResetToOptimized(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
}

export class ReadClient {
    public transformOptions: (opts: any) => Promise<any> = opts => Promise.resolve(opts);
private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getConfigInputsAllValues(projectId: number, unitId: number): Promise<ConfigInputsUIResponse> {
        let url_ = this.baseUrl + "/readapi/GetConfigInputsAllValues/{projectId}/{unitId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        if (unitId === undefined || unitId === null)
            throw new Error("The parameter 'unitId' must be defined.");
        url_ = url_.replace("{unitId}", encodeURIComponent("" + unitId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetConfigInputsAllValues(_response);
        });
    }

    protected processGetConfigInputsAllValues(response: Response): Promise<ConfigInputsUIResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ConfigInputsUIResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConfigInputsUIResponse>(<any>null);
    }

    getSupplementalDetailsValues(projectId: number, unitId: number): Promise<SupplementalDetailsUIResponse> {
        let url_ = this.baseUrl + "/readapi/GetSupplementalDetailsValues/{projectId}/{unitId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        if (unitId === undefined || unitId === null)
            throw new Error("The parameter 'unitId' must be defined.");
        url_ = url_.replace("{unitId}", encodeURIComponent("" + unitId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSupplementalDetailsValues(_response);
        });
    }

    protected processGetSupplementalDetailsValues(response: Response): Promise<SupplementalDetailsUIResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <SupplementalDetailsUIResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SupplementalDetailsUIResponse>(<any>null);
    }

    getInletOutletValues(projectId: number, unitId: number): Promise<InletOutletUIResponse> {
        let url_ = this.baseUrl + "/readapi/GetInletOutletValues/{projectId}/{unitId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        if (unitId === undefined || unitId === null)
            throw new Error("The parameter 'unitId' must be defined.");
        url_ = url_.replace("{unitId}", encodeURIComponent("" + unitId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInletOutletValues(_response);
        });
    }

    protected processGetInletOutletValues(response: Response): Promise<InletOutletUIResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <InletOutletUIResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InletOutletUIResponse>(<any>null);
    }

    getTempsAndSystemValues(projectId: number, unitId: number): Promise<TempsAndSystemUIResponse> {
        let url_ = this.baseUrl + "/readapi/GetTempsAndSystemValues/{projectId}/{unitId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        if (unitId === undefined || unitId === null)
            throw new Error("The parameter 'unitId' must be defined.");
        url_ = url_.replace("{unitId}", encodeURIComponent("" + unitId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTempsAndSystemValues(_response);
        });
    }

    protected processGetTempsAndSystemValues(response: Response): Promise<TempsAndSystemUIResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <TempsAndSystemUIResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TempsAndSystemUIResponse>(<any>null);
    }

    getOptimizeDesignValues(projectId: number, unitId: number): Promise<InletOutletUIResponse> {
        let url_ = this.baseUrl + "/readapi/GetOptimizeDesignValues/{projectId}/{unitId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        if (unitId === undefined || unitId === null)
            throw new Error("The parameter 'unitId' must be defined.");
        url_ = url_.replace("{unitId}", encodeURIComponent("" + unitId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOptimizeDesignValues(_response);
        });
    }

    protected processGetOptimizeDesignValues(response: Response): Promise<InletOutletUIResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <InletOutletUIResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InletOutletUIResponse>(<any>null);
    }

    getLayoutSchematicSvg(projectId: number, unitId: number): Promise<SchematicResponse> {
        let url_ = this.baseUrl + "/readapi/GetLayoutSchematicSvg/{projectId}/{unitId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        if (unitId === undefined || unitId === null)
            throw new Error("The parameter 'unitId' must be defined.");
        url_ = url_.replace("{unitId}", encodeURIComponent("" + unitId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLayoutSchematicSvg(_response);
        });
    }

    protected processGetLayoutSchematicSvg(response: Response): Promise<SchematicResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <SchematicResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SchematicResponse>(<any>null);
    }

    getConnectionSchematicSvg(projectId: number, unitId: number): Promise<SchematicResponse> {
        let url_ = this.baseUrl + "/readapi/GetConnectionSchematicSvg/{projectId}/{unitId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        if (unitId === undefined || unitId === null)
            throw new Error("The parameter 'unitId' must be defined.");
        url_ = url_.replace("{unitId}", encodeURIComponent("" + unitId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetConnectionSchematicSvg(_response);
        });
    }

    protected processGetConnectionSchematicSvg(response: Response): Promise<SchematicResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <SchematicResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SchematicResponse>(<any>null);
    }
}

export class WriteClient {
    public transformOptions: (opts: any) => Promise<any> = opts => Promise.resolve(opts);
private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    updateConfigInputs(request: FieldUpdateRequest): Promise<ConfigInputsUIResponse> {
        let url_ = this.baseUrl + "/writeapi/updateConfigInputs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateConfigInputs(_response);
        });
    }

    protected processUpdateConfigInputs(response: Response): Promise<ConfigInputsUIResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ConfigInputsUIResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConfigInputsUIResponse>(<any>null);
    }

    updateInletOutlet(request: FieldUpdateRequest): Promise<InletOutletUIResponse> {
        let url_ = this.baseUrl + "/writeapi/updateInletOutlet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateInletOutlet(_response);
        });
    }

    protected processUpdateInletOutlet(response: Response): Promise<InletOutletUIResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <InletOutletUIResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InletOutletUIResponse>(<any>null);
    }

    updateTempsAndSystem(request: FieldUpdateRequest): Promise<TempsAndSystemUIResponse> {
        let url_ = this.baseUrl + "/writeapi/updateTempsAndSystem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateTempsAndSystem(_response);
        });
    }

    protected processUpdateTempsAndSystem(response: Response): Promise<TempsAndSystemUIResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <TempsAndSystemUIResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TempsAndSystemUIResponse>(<any>null);
    }

    updateOptimizeDesign(request: FieldUpdateRequest): Promise<ConfigInputsUIResponse> {
        let url_ = this.baseUrl + "/writeapi/updateOptimizeDesign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateOptimizeDesign(_response);
        });
    }

    protected processUpdateOptimizeDesign(response: Response): Promise<ConfigInputsUIResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ConfigInputsUIResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConfigInputsUIResponse>(<any>null);
    }

    updateSupplementalDetails(request: FieldUpdateRequest): Promise<ConfigInputsUIResponse> {
        let url_ = this.baseUrl + "/writeapi/updateWarranty";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateSupplementalDetails(_response);
        });
    }

    protected processUpdateSupplementalDetails(response: Response): Promise<ConfigInputsUIResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ConfigInputsUIResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConfigInputsUIResponse>(<any>null);
    }
}

export interface TokenResponse {
    access_token?: string | undefined;
    token_type?: string | undefined;
}

export interface GenerateTokenModel {
    username: string;
    password: string;
}

export interface StandardResponse {
    hasError?: boolean;
    errorMessage?: string | undefined;
}

export interface ProjectListResponse extends StandardResponse {
    projectDtoList?: ProjectDTO[] | undefined;
}

export interface ProjectDTO {
    id?: number;
    guid?: string;
    name?: string | undefined;
    statusTypeID?: number | undefined;
    statusTypeName?: string | undefined;
    location?: string | undefined;
    repOfficeID?: string | undefined;
    repContactID?: string | undefined;
    innoventSalesEngineerID?: string | undefined;
    contractorName?: string | undefined;
    buildingType?: string | undefined;
    notes?: string | undefined;
    projectFileString?: string | undefined;
    createDate?: Date | undefined;
    createdByID?: string | undefined;
    lastModifiedDate?: Date | undefined;
    lastModifiedByID?: string | undefined;
    createdByFirstName?: string | undefined;
    createdByLastName?: string | undefined;
    userType?: string | undefined;
    officeName?: string | undefined;
    email?: string | undefined;
    units?: UnitDTO[] | undefined;
}

export interface UnitDTO {
    id?: number;
    guid?: string | undefined;
    projectID?: number;
    unitQuantity?: number | undefined;
    unitTag?: string | undefined;
    createDate?: Date | undefined;
    createdByID?: string | undefined;
    lastModifiedDate?: Date | undefined;
    lastModifiedByID?: string | undefined;
    modelNumber?: string | undefined;
    lastFullSave?: Date | undefined;
}

export interface EnumListResponse extends StandardResponse {
    enumDtoList?: EnumDTO[] | undefined;
}

export interface EnumDTO {
    categoryID?: number | undefined;
    category?: string | undefined;
    enumID?: number | undefined;
    enumName?: string | undefined;
    numericValue?: number | undefined;
    textValue?: string | undefined;
    displayValue?: string | undefined;
}

export interface ProjectResponse extends StandardResponse {
    projectDto?: ProjectDTO | undefined;
}

export interface ProjectRequest {
    id?: number;
    createdByID?: string | undefined;
    createdByFirstName?: string | undefined;
    createdByLastName?: string | undefined;
    projectName?: string | undefined;
    email?: string | undefined;
    userType?: string | undefined;
    officeId?: string | undefined;
    officeName?: string | undefined;
}

export interface UnitResponse extends StandardResponse {
    unitDto?: UnitDTO | undefined;
}

export interface UnitListResponse extends StandardResponse {
    unitDtoList?: UnitDTO[] | undefined;
}

export interface UnitOutputDocListResponse extends StandardResponse {
    outputDocUnitList?: UnitOutputDocumentDTO[] | undefined;
}

export interface UnitOutputDocumentDTO {
    unitId?: number;
    needsFullSave?: boolean | undefined;
    overallHeight?: number | undefined;
    overallLength?: number | undefined;
    isOversized?: boolean;
    unitTag?: string | undefined;
}

export interface DeleteProjectRequest {
    createdByID?: string | undefined;
    projectID?: number;
}

export interface CopyUnitRequest {
    createdByID?: string | undefined;
    unitID?: number;
    unitTag?: string | undefined;
    targetProjectID?: number;
}

export interface CopyProjectRequest {
    createdByID?: string | undefined;
    projectID?: number;
    projectName?: string | undefined;
}

export interface ProjectAndUnitNameResponse extends StandardResponse {
    projectName?: string | undefined;
    unitTag?: string | undefined;
}

export interface StandardResponse2 {
    hasError?: boolean;
    errorMessage?: string | undefined;
}

export interface UnitDrawingResponse extends StandardResponse2 {
    drawings?: UnitDrawingItem[] | undefined;
    dataPropertyErrors?: string[] | undefined;
    hasFatalDataError?: boolean;
}

export interface UnitDrawingItem {
    unitDrawingSvg?: string | undefined;
    viewType?: DrawingTypeView | undefined;
}

export interface DrawingTypeView {
    view?: number;
    type?: number;
}

export interface UnitFanResponse extends StandardResponse {
    unitFanPerformanceDTO?: UnitFanPerformanceDTO | undefined;
}

export interface UnitFanPerformanceDTO {
    unitFanID?: number;
    volumeCfm?: number | undefined;
    operatingPower?: number | undefined;
    requiredPower?: number | undefined;
    fanSpeedRpm?: number | undefined;
    maxFanSpeedRpm?: number | undefined;
    operatingFrequency?: number | undefined;
    elevation?: number | undefined;
    feg?: number | undefined;
    staticEfficiencyPercent?: number | undefined;
    class?: string | undefined;
    driveType?: string | undefined;
    motorSpeedRpm?: number | undefined;
    unitElectricalVoltageTypeEnum?: number | undefined;
    externalStaticPressure?: number | undefined;
    casingLoss?: number | undefined;
    outsideAirPrefilterClean?: number | undefined;
    outsideAirPrefilterLoading?: number | undefined;
    outsideAirHighEfficiencyFilterClean?: number | undefined;
    outsideAirHighEfficiencyFilterLoading?: number | undefined;
    hotWaterPreheatCoilStaticPressure?: number | undefined;
    electricPreheatStaticPressure?: number | undefined;
    heatRecoveryWheelStaticPressure?: number | undefined;
    dxcoilStaticPressure?: number | undefined;
    hotGasReheatCoilStaticPressure?: number | undefined;
    indirectFiredFurnaceStaticPressure?: number | undefined;
    chilledWaterCoilStaticPressure?: number | undefined;
    hotWaterCoilStaticPressure?: number | undefined;
    steamCoilStaticPressure?: number | undefined;
    electricHeaterStaticPressure?: number | undefined;
    humidifierManifoldStaticPressure?: number | undefined;
    plateHeatExchangerStaticPressure?: number | undefined;
    soundAttenuatorStaticPressure?: number | undefined;
    returnAirFilterClean?: number | undefined;
    returnAirFilterLoading?: number | undefined;
    supplyAirFilterClean?: number | undefined;
    supplyAirFilterLoading?: number | undefined;
    inletSoundlevel63hz?: number | undefined;
    inletSoundlevel125hz?: number | undefined;
    inletSoundlevel250hz?: number | undefined;
    inletSoundlevel500hz?: number | undefined;
    inletSoundlevel1000hz?: number | undefined;
    inletSoundlevel2000hz?: number | undefined;
    inletSoundlevel4000hz?: number | undefined;
    inletSoundlevel8000hz?: number | undefined;
    inletPowerWeightedLwA?: number | undefined;
    inletPressureWeightedDBa?: number | undefined;
    inletPerceivedLoudnessSones?: number | undefined;
    outletSoundlevel63hz?: number | undefined;
    outletSoundlevel125hz?: number | undefined;
    outletSoundlevel250hz?: number | undefined;
    outletSoundlevel500hz?: number | undefined;
    outletSoundlevel1000hz?: number | undefined;
    outletSoundlevel2000hz?: number | undefined;
    outletSoundlevel4000hz?: number | undefined;
    outletSoundlevel8000hz?: number | undefined;
    outletPowerWeightedLwA?: number | undefined;
    outletPressureWeightedDBa?: number | undefined;
    outletPerceivedLoudnessSones?: number | undefined;
}

export interface StandardResponse3 {
    hasError?: boolean;
    errorMessage?: string | undefined;
}

export interface ApplicationDataResponse extends StandardResponse3 {
    applicationDataList?: ApplicationDataDTO[] | undefined;
}

export interface ApplicationDataDTO {
    application?: string | undefined;
    key?: string | undefined;
    value?: string | undefined;
}

export interface ContactUsEmailRequest {
    userEmail?: string | undefined;
    message?: string | undefined;
    userName?: string | undefined;
    userPhone?: string | undefined;
}

export interface SpecMateDocumentsRequest {
    projectID?: number;
    unitIDs?: number[] | undefined;
    submittalCoverSheet?: boolean;
    performanceDataSummary?: boolean;
    unitDrawing?: boolean;
    salesGuidSpecification?: boolean;
    salesScope?: boolean;
    versionTemplate?: string | undefined;
}

export interface PDFRequest {
    projectID?: number;
    unitIDs?: number[] | undefined;
    versionTemplate?: string | undefined;
    isInternalUser?: boolean;
}

export interface PdfProcessingRequest {
    environment?: string | undefined;
    requestId?: string | undefined;
    userId?: string | undefined;
    projectId?: number;
    unitIds?: number[] | undefined;
    submittalCoverSheet?: boolean;
    performanceDataSummary?: boolean;
    unitDrawing?: boolean;
    salesGuidSpecification?: boolean;
    salesScope?: boolean;
    guideSpecVersionTemplate?: string | undefined;
}

export interface PdfProcessingResponse extends StandardResponse {
    pdfProcessingDTOs?: PdfProcessingDTO[] | undefined;
}

export interface PdfProcessingDTO {
    id?: number;
    requestId?: string | undefined;
    userId?: string | undefined;
    projectId?: number | undefined;
    unitIds?: number[] | undefined;
    unitIdListString?: string | undefined;
    processingStatusId?: number;
    processingStatusName?: string | undefined;
    pdfUrl?: string | undefined;
    errorMessage?: string | undefined;
    createDate?: Date | undefined;
    lastModifiedDate?: Date | undefined;
}

export interface ProjectData {
    frozenEntityTypes: { [key: string] : string; };
    uiEntities: any[];
    geometries: GeometryBase[];
}

export interface GeometryBase {
}

export interface Box extends GeometryBase {
    key?: string | undefined;
    matrix?: number[] | undefined;
    size3?: Size3 | undefined;
}

export interface Size3 {
    xSize?: number;
    ySize?: number;
    zSize?: number;
}

export interface ApiError {
    apiErrorCode?: ApiErrorCode;
    errorMessage?: string | undefined;
}

export enum ApiErrorCode {
    DeserializeProjectError = 0, 
    ModifyPropertyBadValueError = 1, 
    ModifyPropertyError = 2, 
    NoSuchUnitError = 3, 
    DeletePropertyError = 4, 
    DatabaseError = 5, 
}

export interface PropertyModification {
    unitId?: number | undefined;
    propertyName: string;
    entityTypedRefPath?: TypedRefPathDto | undefined;
    newValue?: string | undefined;
}

export interface TypedRefPathDto {
    atoms?: TypedRefAtom[] | undefined;
    entityType?: string | undefined;
}

export interface TypedRefAtom {
    value?: string | undefined;
}

export interface PropertyDeletion {
    propertyName: string;
    entityTypedRefPath?: TypedRefPathDto | undefined;
}

export interface ModifySelectedModelResult {
    excessiveCasingDimension?: number | undefined;
}

export interface ModifyCasingSizeLimitResult {
    componentNamesReset?: string[] | undefined;
}

export enum DrawingScreen {
    Drawing = 0, 
    CoilConnections = 1, 
    ElectricalFurnacePanels = 2, 
    AccessDoors = 3, 
    LengthInputs = 4, 
}

export interface UIEntity {
}

export interface ConfigurationInputsUI extends UIEntity {
    unitType?: UIPropertyOfUnitType | undefined;
    soundAttenuator?: UIPropertyOfSoundAttenuatorType | undefined;
    humidifierManifold?: UIPropertyOfHumidifierManifoldType | undefined;
    showSoundAttenuatorLength?: boolean;
    unitTag?: UIPropertyOfString | undefined;
    unitQuantity?: UIPropertyOfInt32 | undefined;
    energyRecoveryDevice?: UIPropertyOfEnergyRecoveryDeviceType | undefined;
    unitLocation?: UIPropertyOfUnitLocationType | undefined;
    airflowArrangement?: UIPropertyOfAirflowArrangementType | undefined;
    layoutSchematicSvg?: string | undefined;
    cfmLimit?: boolean;
    outsideAirAltitudeOnlyAcfm?: UIPropertyOfNullableOfDouble | undefined;
    supplyAirAltitudeOnlyAcfm?: UIPropertyOfNullableOfDouble | undefined;
    returnAirAltitudeOnlyAcfm?: UIPropertyOfNullableOfDouble | undefined;
    exhaustAirAltitudeOnlyAcfm?: UIPropertyOfNullableOfDouble | undefined;
    airTunnelOrientation?: UIPropertyOfAirTunnelOrientation | undefined;
    returnAirDirection?: UIPropertyOfReturnAirDirection | undefined;
    supplyTunnelLocation?: UIPropertyOfTunnelLocation | undefined;
    showUnitLayoutInputs?: boolean;
    cooling?: UIPropertyOfCooling | undefined;
    heating?: UIPropertyOfHeating | undefined;
    coolHeatSequence?: UIPropertyOfCoolHeatSequence | undefined;
    preHeat?: UIPropertyOfHeating | undefined;
    outsideAirPrefilter?: UIPropertyOfFilterType | undefined;
    outsideAirHighEfficiencyFilter?: UIPropertyOfFilterType | undefined;
    supplyAirFinalFilter?: UIPropertyOfFilterType | undefined;
    returnAirFilter?: UIPropertyOfFilterType | undefined;
    showSupplyAndReturnAirAltitudeOnlyAcfm?: boolean;
    showCoolHeatSequence?: boolean;
    disableCoolHeatSequence?: boolean;
    disableReturnAirDirection?: boolean;
}

export interface UIProperty {
    id: RefPath;
    validationMessage?: string | undefined;
    entityType?: string | undefined;
}

export interface UIPropertyOfUnitType extends UIProperty {
    value?: UnitType;
    choices?: IUIPropertyChoicesListOfUnitType | undefined;
}

export enum UnitType {
    NotSet = 0, 
    SingleTunnel = 1, 
    EnergyRecovery = 2, 
}

export interface IUIPropertyChoicesListOfUnitType {
}

export interface RefPath {
    headAtomValueUnsafe?: string | undefined;
}

export interface UIPropertyOfSoundAttenuatorType extends UIProperty {
    value?: SoundAttenuatorType;
    choices?: IUIPropertyChoicesListOfSoundAttenuatorType | undefined;
}

export enum SoundAttenuatorType {
    None = 0, 
    Supply = 1, 
    Return = 2, 
    SupplyAndReturn = 3, 
}

export interface IUIPropertyChoicesListOfSoundAttenuatorType {
}

export interface UIPropertyOfHumidifierManifoldType extends UIProperty {
    value?: HumidifierManifoldType;
    choices?: IUIPropertyChoicesListOfHumidifierManifoldType | undefined;
}

export enum HumidifierManifoldType {
    None = 0, 
    Supply = 1, 
}

export interface IUIPropertyChoicesListOfHumidifierManifoldType {
}

export interface UIPropertyOfString extends UIProperty {
    value?: string | undefined;
    choices?: IUIPropertyChoicesListOfString | undefined;
}

export interface IUIPropertyChoicesListOfString {
}

export interface UIPropertyOfInt32 extends UIProperty {
    value?: number;
    choices?: IUIPropertyChoicesListOfInt32 | undefined;
}

export interface IUIPropertyChoicesListOfInt32 {
}

export interface UIPropertyOfEnergyRecoveryDeviceType extends UIProperty {
    value?: EnergyRecoveryDeviceType;
    choices?: IUIPropertyChoicesListOfEnergyRecoveryDeviceType | undefined;
}

export enum EnergyRecoveryDeviceType {
    ChooseAnOption = 0, 
    SensiblePlate = 1, 
    EnthalpyWheel = 2, 
}

export interface IUIPropertyChoicesListOfEnergyRecoveryDeviceType {
}

export interface UIPropertyOfUnitLocationType extends UIProperty {
    value?: UnitLocationType;
    choices?: IUIPropertyChoicesListOfUnitLocationType | undefined;
}

export enum UnitLocationType {
    NotSet = 0, 
    Outdoor = 1, 
    Indoor = 2, 
}

export interface IUIPropertyChoicesListOfUnitLocationType {
}

export interface UIPropertyOfAirflowArrangementType extends UIProperty {
    value?: AirflowArrangementType;
    choices?: IUIPropertyChoicesListOfAirflowArrangementType | undefined;
}

export enum AirflowArrangementType {
    NotSet = 0, 
    _100PercentOA = 1, 
    PartialRecircWithEconomizer = 2, 
    PartialRecircWOEconomizer = 3, 
}

export interface IUIPropertyChoicesListOfAirflowArrangementType {
}

export interface UIPropertyOfNullableOfDouble extends UIProperty {
    value?: number | undefined;
    choices?: IUIPropertyChoicesListOfNullableOfDouble | undefined;
}

export interface IUIPropertyChoicesListOfNullableOfDouble {
}

export interface UIPropertyOfAirTunnelOrientation extends UIProperty {
    value?: AirTunnelOrientation;
    choices?: IUIPropertyChoicesListOfAirTunnelOrientation | undefined;
}

export enum AirTunnelOrientation {
    NotSet = 0, 
    Stacked = 1, 
    SideBySide = 2, 
}

export interface IUIPropertyChoicesListOfAirTunnelOrientation {
}

export interface UIPropertyOfReturnAirDirection extends UIProperty {
    value?: ReturnAirDirection;
    choices?: IUIPropertyChoicesListOfReturnAirDirection | undefined;
}

export enum ReturnAirDirection {
    NotSet = 0, 
    ParallelToOA = 1, 
    OppositeOfOA = 2, 
}

export interface IUIPropertyChoicesListOfReturnAirDirection {
}

export interface UIPropertyOfTunnelLocation extends UIProperty {
    value?: TunnelLocation;
    choices?: IUIPropertyChoicesListOfTunnelLocation | undefined;
}

export enum TunnelLocation {
    NotSet = 0, 
    Bottom = 1, 
    Top = 2, 
    Front = 3, 
    Back = 4, 
    Single = 5, 
}

export interface IUIPropertyChoicesListOfTunnelLocation {
}

export interface UIPropertyOfCooling extends UIProperty {
    value?: Cooling;
    choices?: IUIPropertyChoicesListOfCooling | undefined;
}

export enum Cooling {
    None = 0, 
    ChilledWater = 1, 
    DXPackaged = 2, 
    DXPackagedWithHotGasReheat = 3, 
    DXSplit = 4, 
    DXSplitWithHotGasReheat = 5, 
}

export interface IUIPropertyChoicesListOfCooling {
}

export interface UIPropertyOfHeating extends UIProperty {
    value?: Heating;
    choices?: IUIPropertyChoicesListOfHeating | undefined;
}

export enum Heating {
    None = 0, 
    HotWater = 1, 
    Steam = 2, 
    IndirectFiredFurnace = 3, 
    Electric = 4, 
}

export interface IUIPropertyChoicesListOfHeating {
}

export interface UIPropertyOfCoolHeatSequence extends UIProperty {
    value?: CoolHeatSequence;
    choices?: IUIPropertyChoicesListOfCoolHeatSequence | undefined;
}

export enum CoolHeatSequence {
    NotSet = 0, 
    HeatCool = 1, 
    CoolHeat = 2, 
}

export interface IUIPropertyChoicesListOfCoolHeatSequence {
}

export interface UIPropertyOfFilterType extends UIProperty {
    value?: FilterType;
    choices?: IUIPropertyChoicesListOfFilterType | undefined;
}

export enum FilterType {
    None = 0, 
    MERV8_2Inch = 1, 
    MERV13_2Inch = 2, 
    MERV8_4Inch = 3, 
    MERV13_4Inch = 4, 
    MERV11_4Inch = 5, 
    MERV15_4Inch = 6, 
    MERV11_12Inch = 7, 
    MERV13_12Inch = 8, 
    MERV15_12Inch = 9, 
    HEPA9997_12Inch = 10, 
    HEPA9999_12Inch = 11, 
    HEPA99999_12Inch = 12, 
    MERV14_4Inch = 13, 
    MERV14_12Inch = 14, 
}

export interface IUIPropertyChoicesListOfFilterType {
}

export interface ConnectionsAndOptionsUI extends UIEntity {
    showVestibule?: boolean;
    outsideAirInlet?: UIPropertyOfAirInletOrOutletType | undefined;
    supplyAirOutlet?: UIPropertyOfAirInletOrOutletType | undefined;
    returnAirInlet?: UIPropertyOfAirInletOrOutletType | undefined;
    exhaustAirOutlet?: UIPropertyOfAirInletOrOutletType | undefined;
    outsideAirInletLocation?: UIPropertyOfAirInletOrOutletLocationType | undefined;
    supplyAirOutletLocation?: UIPropertyOfAirInletOrOutletLocationType | undefined;
    returnAirInletLocation?: UIPropertyOfAirInletOrOutletLocationType | undefined;
    exhaustAirOutletLocation?: UIPropertyOfAirInletOrOutletLocationType | undefined;
    disableOutsideAirInletOrExhaustAirOutlet?: boolean;
    connectionsSchematicSvg?: string | undefined;
}

export interface UIPropertyOfAirInletOrOutletType extends UIProperty {
    value?: AirInletOrOutletType;
    choices?: IUIPropertyChoicesListOfAirInletOrOutletType | undefined;
}

export enum AirInletOrOutletType {
    Duct = 1, 
    Hood = 2, 
    Louver = 3, 
}

export interface IUIPropertyChoicesListOfAirInletOrOutletType {
}

export interface UIPropertyOfAirInletOrOutletLocationType extends UIProperty {
    value?: AirInletOrOutletLocationType;
    choices?: IUIPropertyChoicesListOfAirInletOrOutletLocationType | undefined;
}

export enum AirInletOrOutletLocationType {
    LeftEnd = 1, 
    RightEnd = 2, 
    FrontSide = 3, 
    BackSide = 4, 
    Top = 5, 
    Bottom = 6, 
}

export interface IUIPropertyChoicesListOfAirInletOrOutletLocationType {
}

export interface TempsAndSystemUI extends UIEntity {
    elevation?: UIPropertyOfDouble | undefined;
    predefinedClimateOption?: UIPropertyOfPredefinedClimateOptionType | undefined;
    outsideSummerDryBulb?: UIPropertyOfNullableOfDouble | undefined;
    outsideSummerWetBulb?: UIPropertyOfNullableOfDouble | undefined;
    outsideWinterDryBulb?: UIPropertyOfNullableOfDouble | undefined;
    supplyESP?: UIPropertyOfDouble | undefined;
    returnESP?: UIPropertyOfDouble | undefined;
    airflowSystem?: UIPropertyOfAirflowSystemType | undefined;
    unitElectricalVoltage?: UIPropertyOfUnitElectricalVoltageType | undefined;
    returnSummerDryBulb?: UIPropertyOfDouble | undefined;
    returnSummerRelativeHumidity?: UIPropertyOfDouble | undefined;
    returnWinterDryBulb?: UIPropertyOfDouble | undefined;
    returnWinterRelativeHumidity?: UIPropertyOfDouble | undefined;
    coolingOffCoilDryBulb?: UIPropertyOfNullableOfDouble | undefined;
    preheatDryBulb?: UIPropertyOfNullableOfDouble | undefined;
    reheatTemp?: UIPropertyOfNullableOfDouble | undefined;
    heatingTemp?: UIPropertyOfNullableOfDouble | undefined;
    showReheatTemp?: boolean;
    showPreheatDryBulbTemp?: boolean;
    preHeat?: UIPropertyOfHeating | undefined;
}

export interface UIPropertyOfDouble extends UIProperty {
    value?: number;
    choices?: IUIPropertyChoicesListOfDouble | undefined;
}

export interface IUIPropertyChoicesListOfDouble {
}

export interface UIPropertyOfPredefinedClimateOptionType extends UIProperty {
    value?: PredefinedClimateOptionType;
    choices?: IUIPropertyChoicesListOfPredefinedClimateOptionType | undefined;
}

export enum PredefinedClimateOptionType {
    None = 0, 
}

export interface IUIPropertyChoicesListOfPredefinedClimateOptionType {
}

export interface UIPropertyOfAirflowSystemType extends UIProperty {
    value?: AirflowSystemType;
    choices?: IUIPropertyChoicesListOfAirflowSystemType | undefined;
}

export enum AirflowSystemType {
    ChooseAnOption = 0, 
    ConstantVolume = 1, 
    VariableAirVolume = 2, 
}

export interface IUIPropertyChoicesListOfAirflowSystemType {
}

export interface UIPropertyOfUnitElectricalVoltageType extends UIProperty {
    value?: UnitElectricalVoltageType;
    choices?: IUIPropertyChoicesListOfUnitElectricalVoltageType | undefined;
}

export enum UnitElectricalVoltageType {
    NotSet = 0, 
    _208_3_60 = 1, 
    _230_3_60 = 2, 
    _460_3_60 = 3, 
    _575_3_60 = 4, 
}

export interface IUIPropertyChoicesListOfUnitElectricalVoltageType {
}

export interface UiScreenResultOfPerformanceUI {
    uiScreen?: PerformanceUI | undefined;
    propertyErrorsByScreenName?: { [key: string] : string[]; } | undefined;
}

export interface PerformanceUI extends UIEntity {
    coilAndFilterFpmLimit?: UIPropertyOfDouble | undefined;
    casingDimensionLimitType?: UIPropertyOfCasingDimensionLimitType | undefined;
    casingHeightOrWidthLimit?: UIPropertyOfNullableOfDouble | undefined;
    excessiveCasingDimension?: UIPropertyOfNullableOfDouble | undefined;
    casingWallThickness?: UIPropertyOfDouble | undefined;
    overallHeight?: number;
    overallWidth?: number;
    isAHUUnitType?: boolean;
    designPerformanceResult?: DesignPerformanceResult | undefined;
    isCustomizedDesign?: boolean;
    customizeButtonEnabled?: boolean;
    panelInfos?: ComponentPerformancePanelInfo[] | undefined;
}

export interface UIPropertyOfCasingDimensionLimitType extends UIProperty {
    value?: CasingDimensionLimitType;
    choices?: IUIPropertyChoicesListOfCasingDimensionLimitType | undefined;
}

export enum CasingDimensionLimitType {
    None = 0, 
    Height = 1, 
    Width = 2, 
}

export interface IUIPropertyChoicesListOfCasingDimensionLimitType {
}

export interface DesignPerformanceResult {
    casingHeight?: number;
    casingWidth?: number;
    approxWeight?: number;
    budgetPrice?: number;
    heatingLeavingTemp?: number | undefined;
    coolingLeavingTemp?: number | undefined;
    coolingReheatTemp?: number | undefined;
    mca?: number;
    mop?: number;
}

export interface ComponentPerformancePanelInfo {
    panelType?: ComponentPerformancePanelType;
    title?: string | undefined;
    subTitle?: string | undefined;
    componentUiId?: string | undefined;
}

export enum ComponentPerformancePanelType {
    HeatWheel = 0, 
    PlateHeatExchanger = 1, 
    ChilledWaterCoil = 2, 
    Refrigeration = 3, 
    DirectExpansionCoil = 4, 
    HotGasReheatCoil = 5, 
    HotWaterCoil = 6, 
    SteamCoil = 7, 
    IndirectFiredFurnace = 8, 
    ElectricHeater = 9, 
    HumidifierManifold = 10, 
    Fan = 11, 
    Filter = 12, 
    SoundAttenuator = 13, 
}

export interface OptimizedPerformanceResponse {
    designPerformanceResult?: DesignPerformanceResult | undefined;
    hasError?: boolean;
    errorMessage?: string | undefined;
}

export interface ComponentsUI {
    heatWheelComponent?: HeatWheelComponentUI | undefined;
    plateHXComponent?: PlateHXComponentUI | undefined;
    idfComponent?: IDFComponentUI | undefined;
    chilledWaterCoilComponent?: ChilledWaterCoilComponentUI | undefined;
    hotWaterCoilComponent?: HotWaterCoilComponentUI | undefined;
    preHeatHotWaterCoilComponent?: HotWaterCoilComponentUI | undefined;
    electricHeaterComponent?: ElectricHeaterComponentUI | undefined;
    preHeatElectricHeaterComponent?: ElectricHeaterComponentUI | undefined;
    dxCoilComponent?: DxCoilComponentUI | undefined;
    hotGasReheatComponent?: HotGasReheatComponentUI | undefined;
    steamCoilComponent?: SteamCoilComponentUI | undefined;
    supplyFanComponent?: FanComponentUI | undefined;
    exhaustFanComponent?: FanComponentUI | undefined;
    supplyAirSoundAttenuatorComponent?: SoundAttenuatorComponentUI | undefined;
    returnAirSoundAttenuatorComponent?: SoundAttenuatorComponentUI | undefined;
    humidifierManifoldComponent?: HumidifierManifoldComponentUI | undefined;
    outsideAirPreFilterComponent?: FilterComponentUI | undefined;
    outsideAirFinalFilterComponent?: FilterComponentUI | undefined;
    supplyAirFilterComponent?: FilterComponentUI | undefined;
    returnAirFilterComponent?: FilterComponentUI | undefined;
}

export interface ComponentUI extends UIEntity {
    errorMessages?: string[] | undefined;
    componentUiId?: string | undefined;
}

export interface HeatWheelComponentUI extends ComponentUI {
    heatWheelChoices?: HeatWheelDto[] | undefined;
    summerEffectivenessValues?: EffectivenessValues | undefined;
    winterEffectivenessValues?: EffectivenessValues | undefined;
    defaultHeatWheelModel?: string | undefined;
    selectedHeatWheelModel?: UIPropertyOfString | undefined;
    isSelectionLocked?: UIPropertyOfBoolean | undefined;
    errorMessages?: string[] | undefined;
}

export interface HeatWheelDto {
    modelNumber?: string | undefined;
    displayModelNumber?: string | undefined;
    totalEffectiveness?: number;
    summerLeavingAirTemperature?: number;
    winterLeavingAirTemperature?: number;
    pressureDrop?: number;
}

export interface EffectivenessValues {
    sensibleEffectiveness?: number;
    latentEffectiveness?: number;
    totalEffectiveness?: number;
}

export interface UIPropertyOfBoolean extends UIProperty {
    value?: boolean;
    choices?: IUIPropertyChoicesListOfBoolean | undefined;
}

export interface IUIPropertyChoicesListOfBoolean {
}

export interface PlateHXComponentUI extends ComponentUI {
    isSelectionLocked?: UIPropertyOfBoolean | undefined;
    supplyAirAltitudeOnlyAcfm?: number;
    returnAirAltitudeOnlyAcfm?: number;
    summerTempEfficiency?: number;
    winterTempEfficiency?: number;
    manuallySetSquareAndSpacing?: UIPropertyOfString | undefined;
    manuallySetPlateHxWidthMm?: UIPropertyOfString | undefined;
    selectedPlateHXModel?: UIPropertyOfString | undefined;
    errorMessages?: string[] | undefined;
    plateHXChoices?: PlateHXDisplay[] | undefined;
}

export interface PlateHXDisplay {
    model?: string | undefined;
    sensibleEfficiency?: number;
    summerDesignLat?: number;
    winterDesignLat?: number;
    airPressureDrop?: number;
    squareSize?: number;
    plateSpacing?: string | undefined;
    hxWidthMm?: number;
    targetOaBypassArea?: number;
}

export interface IDFComponentUI extends ComponentUI {
    enteringAirTemperature?: number;
    modelNumber?: string | undefined;
    leavingAirTemperature?: number;
    outputMbh?: number;
    errorMessages?: string[] | undefined;
}

export interface CoilComponentUIOfChilledWaterCoilComponent extends ComponentUI {
    rows?: number;
    finsPerInch?: number;
    rowsOverride?: UIPropertyOfNullableOfInt32 | undefined;
    finsPerInchOverride?: UIPropertyOfNullableOfInt32 | undefined;
    tubeWallThickness?: UIPropertyOfDouble | undefined;
    finMaterial?: UIPropertyOfFinMaterialType | undefined;
    finThickness?: UIPropertyOfDouble | undefined;
}

export interface ChilledWaterCoilComponentUI extends CoilComponentUIOfChilledWaterCoilComponent {
    enteringAirDryBulb?: number;
    enteringAirWetBulb?: number;
    waterPressureDrop?: number;
    leavingAirDryBulb?: number;
    leavingAirWetBulb?: number;
    enteringFluidTemperature?: UIPropertyOfDouble | undefined;
    leavingFluidTemperature?: UIPropertyOfDouble | undefined;
    coilFluidType?: UIPropertyOfCoilFluidType | undefined;
    glycolPercent?: UIPropertyOfDouble | undefined;
    shouldShowGlycolPercent?: boolean;
    airPressureDrop?: number;
    fluidFlowRateGPM?: number;
    maxWaterPressureDrop?: UIPropertyOfDouble | undefined;
    includeTurbulators?: UIPropertyOfBoolean | undefined;
    errorMessages?: string[] | undefined;
}

export interface UIPropertyOfCoilFluidType extends UIProperty {
    value?: CoilFluidType;
    choices?: IUIPropertyChoicesListOfCoilFluidType | undefined;
}

export enum CoilFluidType {
    None = 0, 
    Water = 1, 
    PropyleneGlycol = 2, 
    EthyleneGlycol = 3, 
}

export interface IUIPropertyChoicesListOfCoilFluidType {
}

export interface UIPropertyOfNullableOfInt32 extends UIProperty {
    value?: number | undefined;
    choices?: IUIPropertyChoicesListOfNullableOfInt32 | undefined;
}

export interface IUIPropertyChoicesListOfNullableOfInt32 {
}

export interface UIPropertyOfFinMaterialType extends UIProperty {
    value?: FinMaterialType;
    choices?: IUIPropertyChoicesListOfFinMaterialType | undefined;
}

export enum FinMaterialType {
    Aluminum = 1, 
    Copper = 2, 
}

export interface IUIPropertyChoicesListOfFinMaterialType {
}

export interface CoilComponentUIOfHotWaterCoilComponent extends ComponentUI {
    rows?: number;
    finsPerInch?: number;
    rowsOverride?: UIPropertyOfNullableOfInt32 | undefined;
    finsPerInchOverride?: UIPropertyOfNullableOfInt32 | undefined;
    tubeWallThickness?: UIPropertyOfDouble | undefined;
    finMaterial?: UIPropertyOfFinMaterialType | undefined;
    finThickness?: UIPropertyOfDouble | undefined;
}

export interface HotWaterCoilComponentUI extends CoilComponentUIOfHotWaterCoilComponent {
    enteringAirDryBulb?: number;
    waterPressureDrop?: number;
    leavingAirDryBulb?: number;
    enteringFluidTemperature?: UIPropertyOfDouble | undefined;
    leavingFluidTemperature?: UIPropertyOfDouble | undefined;
    coilFluidType?: UIPropertyOfCoilFluidType | undefined;
    glycolPercent?: UIPropertyOfDouble | undefined;
    shouldShowGlycolPercent?: boolean;
    airPressureDrop?: number;
    fluidFlowRateGPM?: number;
    maxWaterPressureDrop?: UIPropertyOfDouble | undefined;
    includeTurbulators?: UIPropertyOfBoolean | undefined;
    errorMessages?: string[] | undefined;
}

export interface ElectricHeaterComponentUI extends ComponentUI {
    enteringAirDryBulb?: number;
    leavingAirTemp?: number;
    voltage?: number;
    powerKw?: number;
    controlType?: string | undefined;
    amps?: number;
}

export interface CoilComponentUIOfDXCoilComponent extends ComponentUI {
    rows?: number;
    finsPerInch?: number;
    rowsOverride?: UIPropertyOfNullableOfInt32 | undefined;
    finsPerInchOverride?: UIPropertyOfNullableOfInt32 | undefined;
    tubeWallThickness?: UIPropertyOfDouble | undefined;
    finMaterial?: UIPropertyOfFinMaterialType | undefined;
    finThickness?: UIPropertyOfDouble | undefined;
}

export interface DxCoilComponentUI extends CoilComponentUIOfDXCoilComponent {
    isPackaged?: boolean;
    isEnergyRecovery?: boolean;
    hasHGRHCoil?: boolean;
    coolingType?: Cooling;
    enteringAirDryBulb?: number;
    enteringAirWetBulb?: number;
    leavingAirDryBulb?: number;
    leavingAirWetBulb?: number;
    suctionTemperature?: UIPropertyOfDouble | undefined;
    circuitQuantity_UserValue?: UIPropertyOfString | undefined;
    condensingCapacity?: number;
    balancedCircuitQuantity?: number;
    coolingTons?: number;
    forceCircuitQuantityToTwo?: boolean;
    compressorType?: UIPropertyOfCompressorType | undefined;
    ambientTemp?: UIPropertyOfDouble | undefined;
    eer?: number;
    actualCompressorType?: string | undefined;
    includeRifledTubes?: UIPropertyOfBoolean | undefined;
    airPressureDrop?: number;
    errorMessages?: string[] | undefined;
}

export interface UIPropertyOfCompressorType extends UIProperty {
    value?: CompressorType;
    choices?: IUIPropertyChoicesListOfCompressorType | undefined;
}

export enum CompressorType {
    Automatic = 0, 
    VFDScroll = 1, 
    DigitalScroll = 2, 
    StagedScroll = 3, 
}

export interface IUIPropertyChoicesListOfCompressorType {
}

export interface CoilComponentUIOfHotGasReheatCoilComponent extends ComponentUI {
    rows?: number;
    finsPerInch?: number;
    rowsOverride?: UIPropertyOfNullableOfInt32 | undefined;
    finsPerInchOverride?: UIPropertyOfNullableOfInt32 | undefined;
    tubeWallThickness?: UIPropertyOfDouble | undefined;
    finMaterial?: UIPropertyOfFinMaterialType | undefined;
    finThickness?: UIPropertyOfDouble | undefined;
}

export interface HotGasReheatComponentUI extends CoilComponentUIOfHotGasReheatCoilComponent {
    enteringAirTemp?: number;
    leavingAirTemp?: number;
    reheatCircuits?: number;
    airPressureDrop?: number;
    errorMessages?: string[] | undefined;
}

export interface CoilComponentUIOfSteamCoilComponent extends ComponentUI {
    rows?: number;
    finsPerInch?: number;
    rowsOverride?: UIPropertyOfNullableOfInt32 | undefined;
    finsPerInchOverride?: UIPropertyOfNullableOfInt32 | undefined;
    tubeWallThickness?: UIPropertyOfDouble | undefined;
    finMaterial?: UIPropertyOfFinMaterialType | undefined;
    finThickness?: UIPropertyOfDouble | undefined;
}

export interface SteamCoilComponentUI extends CoilComponentUIOfSteamCoilComponent {
    enteringAirTemp?: number;
    leavingAirTemp?: number;
    steamPressure?: UIPropertyOfDouble | undefined;
    steamLoading?: number;
    tubeDiameter?: UIPropertyOfTubeDiameterType | undefined;
    airPressureDrop?: number;
    errorMessages?: string[] | undefined;
}

export interface UIPropertyOfTubeDiameterType extends UIProperty {
    value?: TubeDiameterType;
    choices?: IUIPropertyChoicesListOfTubeDiameterType | undefined;
}

export enum TubeDiameterType {
    ThreeEighths = 1, 
    OneHalf = 2, 
    FiveEighths = 3, 
    One = 4, 
}

export interface IUIPropertyChoicesListOfTubeDiameterType {
}

export interface FanComponentUI extends ComponentUI {
    airflow?: number;
    totalStaticPressure?: number;
    totalStaticPressureOverride?: UIPropertyOfNullableOfDouble | undefined;
    fanQuantity?: number;
    isSideBySideUnit?: boolean;
    minimumFanQuantity?: number;
    minimumFanQuantityInHeight?: number;
    minimumFanQuantityInWidth?: number;
    fanChoices?: FanDto[] | undefined;
    defaultFanKey?: FanKey | undefined;
    selectedFanKey?: UIPropertyOfFanKey | undefined;
    isSelectionLocked?: UIPropertyOfBoolean | undefined;
    errorMessages?: string[] | undefined;
    fanQuantityInHeight?: number;
    fanQuantityInWidth?: number;
    fanQuantityInHeightOverride?: UIPropertyOfNullableOfInt32 | undefined;
    fanQuantityInWidthOverride?: UIPropertyOfNullableOfInt32 | undefined;
}

export interface FanDto {
    fanKey?: FanKey | undefined;
    modelDisplayName?: string | undefined;
    fanRpm?: number;
    motorRpm?: number;
    horsePowerDescription?: string | undefined;
    staticEfficiencyPercent?: number;
    arrayLwaOutletDb?: number;
}

export interface FanKey {
    modelNumber?: string | undefined;
    quantity?: number;
    motorRpm?: number | undefined;
    fanId?: string | undefined;
}

export interface UIPropertyOfFanKey extends UIProperty {
    value?: FanKey | undefined;
    choices?: IUIPropertyChoicesListOfFanKey | undefined;
}

export interface IUIPropertyChoicesListOfFanKey {
}

export interface SoundAttenuatorComponentUI extends ComponentUI {
    soundAttenuatorLength?: UIPropertyOfSoundAttenuatorLengthType | undefined;
    faceVelocity?: number;
    insertionLoss63Hz?: number;
    insertionLoss125Hz?: number;
    insertionLoss250Hz?: number;
    insertionLoss500Hz?: number;
    insertionLoss1000Hz?: number;
    insertionLoss2000Hz?: number;
    insertionLoss4000Hz?: number;
    insertionLoss8000Hz?: number;
}

export interface UIPropertyOfSoundAttenuatorLengthType extends UIProperty {
    value?: SoundAttenuatorLengthType;
    choices?: IUIPropertyChoicesListOfSoundAttenuatorLengthType | undefined;
}

export enum SoundAttenuatorLengthType {
    NotSet = 0, 
    _24 = 1, 
    _36 = 2, 
}

export interface IUIPropertyChoicesListOfSoundAttenuatorLengthType {
}

export interface HumidifierManifoldComponentUI extends ComponentUI {
    airTemp?: number;
    enteringRH?: number;
    steamCapacity?: number;
    steamPressureEnabled?: boolean;
    desiredLeavingRH?: UIPropertyOfNullableOfDouble | undefined;
    steamSource?: UIPropertyOfSteamSourceType | undefined;
    absorptionDistance?: number;
    steamPressure?: UIPropertyOfNullableOfDouble | undefined;
}

export interface UIPropertyOfSteamSourceType extends UIProperty {
    value?: SteamSourceType;
    choices?: IUIPropertyChoicesListOfSteamSourceType | undefined;
}

export enum SteamSourceType {
    SteamGeneratorByOthers = 0, 
    BuildingSteam = 1, 
}

export interface IUIPropertyChoicesListOfSteamSourceType {
}

export interface FilterComponentUI extends ComponentUI {
    loadingLevel?: UIPropertyOfFilterLoadingLevel | undefined;
    filterRemoval?: UIPropertyOfFilterRemoval | undefined;
    filterRemovalDisabled?: boolean;
    type?: string | undefined;
    faceVelocity?: number;
    pressureDrop?: number;
}

export interface UIPropertyOfFilterLoadingLevel extends UIProperty {
    value?: FilterLoadingLevel;
    choices?: IUIPropertyChoicesListOfFilterLoadingLevel | undefined;
}

export enum FilterLoadingLevel {
    Clean = 1, 
    Mean = 2, 
    Dirty = 3, 
}

export interface IUIPropertyChoicesListOfFilterLoadingLevel {
}

export interface UIPropertyOfFilterRemoval extends UIProperty {
    value?: FilterRemoval;
    choices?: IUIPropertyChoicesListOfFilterRemoval | undefined;
}

export enum FilterRemoval {
    Side = 1, 
    Front = 2, 
}

export interface IUIPropertyChoicesListOfFilterRemoval {
}

export interface UnitSelectionUI extends UIEntity {
    unitType?: UIPropertyOfUnitType | undefined;
}

export interface AccessEditingAndDrawingUI extends UIEntity {
    cabinetAndBaseHeight?: number;
    cabinetWidth?: number;
    cabinetLength?: number;
    overallHeight?: number;
    overallWidth?: number;
    overallLength?: number;
    showUnitLengthWarning?: boolean;
    shippingWeight?: number;
    operatingWeight?: number;
    drawingViewInfo?: DrawingViewInfo | undefined;
    hoodAndLouverExtensions?: { [key: string] : number; } | undefined;
}

export interface DrawingViewInfo {
    defaultViewType?: DrawingViewType;
    availableViewTypes?: DrawingViewType[] | undefined;
}

export enum DrawingViewType {
    FrontSide = 0, 
    BackSide = 1, 
    LeftEnd = 2, 
    RightEnd = 3, 
    Top = 4, 
    TopUpperTunnel = 5, 
    TopBottomTunnel = 6, 
}

export interface AccessDoorsUI extends UIEntity {
    unitAccessSide?: UIPropertyOfUnitAccess | undefined;
    topDrawingViewInfo?: DrawingViewInfo | undefined;
}

export interface UIPropertyOfUnitAccess extends UIProperty {
    value?: UnitAccess;
    choices?: IUIPropertyChoicesListOfUnitAccess | undefined;
}

export enum UnitAccess {
    FrontSide = 1, 
    BackSide = 2, 
    Automatic = 3, 
}

export interface IUIPropertyChoicesListOfUnitAccess {
}

export interface CoilConnectionsUI extends UIEntity {
    preHeatHotWaterUnitPenetration?: UIPropertyOfFluidCoilPenetration | undefined;
    chilledWaterUnitPenetration?: UIPropertyOfFluidCoilPenetration | undefined;
    hotWaterUnitPenetration?: UIPropertyOfFluidCoilPenetration | undefined;
    steamUnitPenetration?: UIPropertyOfFluidCoilPenetration | undefined;
    dxUnitPenetration?: UIPropertyOfRefrigerantCoilPenetration | undefined;
    hotGasReheatUnitPenetration?: UIPropertyOfRefrigerantCoilPenetration | undefined;
    topDrawingViewInfo?: DrawingViewInfo | undefined;
}

export interface UIPropertyOfFluidCoilPenetration extends UIProperty {
    value?: FluidCoilPenetration;
    choices?: IUIPropertyChoicesListOfFluidCoilPenetration | undefined;
}

export enum FluidCoilPenetration {
    PipeChase = 1, 
    FrontSide = 2, 
    BackSide = 3, 
}

export interface IUIPropertyChoicesListOfFluidCoilPenetration {
}

export interface UIPropertyOfRefrigerantCoilPenetration extends UIProperty {
    value?: RefrigerantCoilPenetration;
    choices?: IUIPropertyChoicesListOfRefrigerantCoilPenetration | undefined;
}

export enum RefrigerantCoilPenetration {
    None = 0, 
    FrontSideWithinCompressorVestibule = 1, 
    FrontSide = 2, 
    BackSide = 3, 
}

export interface IUIPropertyChoicesListOfRefrigerantCoilPenetration {
}

export interface ElectFurnacePanelsUI extends UIEntity {
    electricalPanelLocation?: UIPropertyOfString | undefined;
    furnacePanelLocation?: UIPropertyOfFurnacePanelLocation | undefined;
    topDrawingViewInfo?: DrawingViewInfo | undefined;
    hasCondensingSection?: boolean;
    airTunnelOrientation?: number | undefined;
    circuitQuantity?: number;
    accuArrangement?: number;
    cabinetAndBaseHeight?: number;
    cabinetWidth?: number;
    cabinetLength?: number;
    overallHeight?: number;
    overallWidth?: number;
    overallLength?: number;
    shippingWeight?: number;
    operatingWeight?: number;
    hoodAndLouverExtensions?: { [key: string] : number; } | undefined;
}

export interface UIPropertyOfFurnacePanelLocation extends UIProperty {
    value?: FurnacePanelLocation;
    choices?: IUIPropertyChoicesListOfFurnacePanelLocation | undefined;
}

export enum FurnacePanelLocation {
    FrontSide = 1, 
    BackSide = 2, 
    BothSides = 3, 
}

export interface IUIPropertyChoicesListOfFurnacePanelLocation {
}

export interface LengthInputsUI extends UIEntity {
    cabinetLength?: number;
    overallLength?: number;
    transitionAngles?: UIPropertyOfDouble | undefined;
    heatingCoolingAccess?: UIPropertyOfHeatingCoolingAccessOption | undefined;
    allowFanDuctOverlap?: UIPropertyOfAllowFanDuctOverlapOption | undefined;
    minFilterDoorLength?: UIPropertyOfDouble | undefined;
    minFanDoorLength?: UIPropertyOfDouble | undefined;
    minEnergyRecoveryDoorLength?: UIPropertyOfDouble | undefined;
    minCoilDoorLength?: UIPropertyOfDouble | undefined;
    allOtherMinDoorLength?: UIPropertyOfDouble | undefined;
    topDrawingViewInfo?: DrawingViewInfo | undefined;
}

export interface UIPropertyOfHeatingCoolingAccessOption extends UIProperty {
    value?: HeatingCoolingAccessOption;
    choices?: IUIPropertyChoicesListOfHeatingCoolingAccessOption | undefined;
}

export enum HeatingCoolingAccessOption {
    BothFaces = 0, 
    SingleFace = 1, 
}

export interface IUIPropertyChoicesListOfHeatingCoolingAccessOption {
}

export interface UIPropertyOfAllowFanDuctOverlapOption extends UIProperty {
    value?: AllowFanDuctOverlapOption;
    choices?: IUIPropertyChoicesListOfAllowFanDuctOverlapOption | undefined;
}

export enum AllowFanDuctOverlapOption {
    No = 0, 
    Yes = 1, 
}

export interface IUIPropertyChoicesListOfAllowFanDuctOverlapOption {
}

export interface ComponentConstructionUI extends UIEntity {
    heatWheelPanel?: HeatWheelPanel | undefined;
    coilPanel?: CoilPanel | undefined;
    indirectFiredFurnacePanel?: IndirectFiredFurnacePanel | undefined;
    accuPanel?: AccuPanel | undefined;
    filterPanel?: FilterPanel | undefined;
    fanPanel?: FanPanel | undefined;
    damperPanel?: DamperPanel | undefined;    
}

export interface HeatWheelPanel extends UIEntity {
    spareBeltsQuantity?: UIPropertyOfNullableOfInt32 | undefined;
}

export interface CoilPanel extends UIEntity {
    coilPanelItems?: CoilPanelItem[] | undefined;
}

export interface CoilPanelItem extends UIEntity {
    componentName?: string | undefined;
    includeUVLights?: UIPropertyOfBoolean | undefined;
    casingConstruction?: UIPropertyOfCasingMaterialType | undefined;
    coating?: UIPropertyOfCoilCoatingType | undefined;
    tubeThickness?: number;
    finMaterial?: string | undefined;
    finThickness?: number;
}

export interface UIPropertyOfCasingMaterialType extends UIProperty {
    value?: CasingMaterialType;
    choices?: IUIPropertyChoicesListOfCasingMaterialType | undefined;
}

export enum CasingMaterialType {
    SixteenGaGalvSteelStd = 1, 
    FourteenGaGalvSteel = 2, 
    SixteenGaStainlessSteel = 3, 
    PointZeroNineThickCopper = 4, 
}

export interface IUIPropertyChoicesListOfCasingMaterialType {
}

export interface UIPropertyOfCoilCoatingType extends UIProperty {
    value?: CoilCoatingType;
    choices?: IUIPropertyChoicesListOfCoilCoatingType | undefined;
}

export enum CoilCoatingType {
    None = 0, 
    BakedPhenolic = 1, 
    EpoxyCoat = 2, 
}

export interface IUIPropertyChoicesListOfCoilCoatingType {
}

export interface IndirectFiredFurnacePanel extends UIEntity {
    tubeMaterial?: UIPropertyOfFurnaceTubeMaterialType | undefined;
    tubeMaterialWarningMessage?: string | undefined;
    fuelType?: UIPropertyOfFurnaceFuelType | undefined;
    minTotalTurnDown?: UIPropertyOfString | undefined;
}

export interface UIPropertyOfFurnaceTubeMaterialType extends UIProperty {
    value?: FurnaceTubeMaterialType;
    choices?: IUIPropertyChoicesListOfFurnaceTubeMaterialType | undefined;
}

export enum FurnaceTubeMaterialType {
    Stainless409 = 1, 
    Stainless304 = 2, 
}

export interface IUIPropertyChoicesListOfFurnaceTubeMaterialType {
}

export interface UIPropertyOfFurnaceFuelType extends UIProperty {
    value?: FurnaceFuelType;
    choices?: IUIPropertyChoicesListOfFurnaceFuelType | undefined;
}

export enum FurnaceFuelType {
    NaturalGas = 1, 
    Propane = 2, 
}

export interface IUIPropertyChoicesListOfFurnaceFuelType {
}

export interface AccuPanel extends UIEntity {
    condenserCoilCoating?: UIPropertyOfCoilCoatingType | undefined;
}

export interface FilterPanel extends UIEntity {
    filterPanelItems?: FilterPanelItem[] | undefined;
}

export interface FilterPanelItem extends UIEntity {
    name?: string | undefined;
    filterCategory?: FilterCategoryType;
    spareFilterSetsQuantity?: UIPropertyOfInt32 | undefined;
}

export enum FilterCategoryType {
    Pleated = 1, 
    Cartridge = 2, 
    HEPA = 3, 
}

export interface FanPanel extends UIEntity {
    fanPanelItems?: FanPanelItem[] | undefined;
}

export interface FanPanelItem extends UIEntity {
    name?: string | undefined;
    motorEnclosure?: UIPropertyOfMotorEnclosureType | undefined;
    shaftGrounding?: UIPropertyOfShaftGroundingType | undefined;
    inletGuard?: UIPropertyOfBoolean | undefined;
    outletSafetyCage?: UIPropertyOfBoolean | undefined;
    includeDoorSafetyKillSwitch?: UIPropertyOfBoolean | undefined;
}

export interface UIPropertyOfMotorEnclosureType extends UIProperty {
    value?: MotorEnclosureType;
    choices?: IUIPropertyChoicesListOfMotorEnclosureType | undefined;
}

export enum MotorEnclosureType {
    TEFC = 1, 
    ODP = 2, 
}

export interface IUIPropertyChoicesListOfMotorEnclosureType {
}

export interface UIPropertyOfShaftGroundingType extends UIProperty {
    value?: ShaftGroundingType;
    choices?: IUIPropertyChoicesListOfShaftGroundingType | undefined;
}

export enum ShaftGroundingType {
    YesForGreaterThanOrEqualTo10hp = 1, 
    Yes = 2, 
    No = 3, 
}

export interface IUIPropertyChoicesListOfShaftGroundingType {
}

export interface DamperPanel extends UIEntity {
    damperPanelItems?: DamperPanelItem[] | undefined;
}

export interface DamperPanelItem extends UIEntity {
    name?: string | undefined;
    motorizedOrGravity?: UIPropertyOfDamperMotorizedOrGravity | undefined;
    typeAndConstruction?: UIPropertyOfDamperTypeAndConstruction | undefined;
    blade?: string | undefined;
    actuator?: string | undefined;
}

export interface UIPropertyOfDamperMotorizedOrGravity extends UIProperty {
    value?: DamperMotorizedOrGravity;
    choices?: IUIPropertyChoicesListOfDamperMotorizedOrGravity | undefined;
}

export enum DamperMotorizedOrGravity {
    Motorized = 1, 
    Gravity = 2, 
}

export interface IUIPropertyChoicesListOfDamperMotorizedOrGravity {
}

export interface UIPropertyOfDamperTypeAndConstruction extends UIProperty {
    value?: DamperTypeAndConstruction;
    choices?: IUIPropertyChoicesListOfDamperTypeAndConstruction | undefined;
}

export enum DamperTypeAndConstruction {
    GalvanizedFormed = 1, 
    GalvanizedAirfoil = 2, 
    AluminumAirfoil = 3, 
    AluminumBladeGalvanizedFrame = 4, 
    Stainless304Formed = 5, 
    Stainless304Airfoil = 6, 
    AluminumAirfoilInsulatedBlade = 7, 
    AluminumAirfoilInsulatedBladeAndFrame = 8, 
    GalvanizedFormedSmoke = 9, 
    GalvanizedAirfoilSmoke = 10, 
    AluminumAirfoilSmoke = 11, 
    GalvanizedFormedAirflowMonitoring = 12, 
    GalvanizedAirfoilAirflowMonitoring = 13, 
    AluminumAirfoilAirflowMonitoring = 14, 
    Aluminum = 15, 
}

export interface IUIPropertyChoicesListOfDamperTypeAndConstruction {
}

export interface InletOutletSizingUI extends UIEntity {
    outsideAirInlet?: InletOutletUI | undefined;
    supplyAirOutlet?: InletOutletUI | undefined;
    returnAirInlet?: InletOutletUI | undefined;
    exhaustAirOutlet?: InletOutletUI | undefined;
}

export interface InletOutletUI extends UIEntity {
    connectionType?: AirInletOrOutletType;
    connectionLocationDisplayName?: string | undefined;
    airflowCFM?: number;
    sizingMethod?: UIPropertyOfOpeningSizingMethod | undefined;
    sizingMethodValidationMessage?: string | undefined;
    dimensionA?: UIPropertyOfNullableOfDouble | undefined;
    dimensionB?: UIPropertyOfNullableOfDouble | undefined;
    dimensionC?: UIPropertyOfNullableOfDouble | undefined;
    dimensionD?: UIPropertyOfNullableOfDouble | undefined;
    dimensionsAreReadOnly?: boolean;
    faceVelocityIsReadOnly?: boolean;
    faceVelocityFpm?: UIPropertyOfDouble | undefined;
}

export interface UIPropertyOfOpeningSizingMethod extends UIProperty {
    value?: OpeningSizingMethod;
    choices?: IUIPropertyChoicesListOfOpeningSizingMethod | undefined;
}

export enum OpeningSizingMethod {
    FullSize = 1, 
    FullWidth = 2, 
    FullHeight = 3, 
    Manual = 4, 
}

export interface IUIPropertyChoicesListOfOpeningSizingMethod {
}

export interface ControlsUI extends UIEntity {
    airflowArrangement?: UIPropertyOfAirflowArrangementType | undefined;
    controlsInclusion?: UIPropertyOfControlsInclusionType | undefined;
    damperActuatorsInclusion?: UIPropertyOfDamperActuatorsInclusionType | undefined;
    outsideAirInletDamperEnabled?: boolean;
    outsideAirInletAirflowMonitoringEnabled?: boolean;
    damperActuatorsInclusionEnabled?: boolean;
    outsideAirInletDamper?: UIPropertyOfBoolean | undefined;
    exhaustAirOutletDamper?: UIPropertyOfBoolean | undefined;
    returnAirInletDamper?: UIPropertyOfBoolean | undefined;
    supplyAirOutletSmokeDamper?: UIPropertyOfBoolean | undefined;
    returnAirInletSmokeDamper?: UIPropertyOfBoolean | undefined;
    outsideAirInletAirflowMonitoring?: UIPropertyOfBoolean | undefined;
    supplyFanAirflowMonitoring?: UIPropertyOfBoolean | undefined;
    showReturnFanAirFlowMonitoring?: boolean;
    returnFanAirflowMonitoring?: UIPropertyOfBoolean | undefined;
    enableSupplyFanAirFlowMonitoring?: boolean;
    showExhaustFanAirFlowMonitoring?: boolean;
    exhaustFanAirflowMonitoring?: UIPropertyOfBoolean | undefined;
    magnehelicGauges?: UIPropertyOfBoolean | undefined;
    vavOrConstantVolume?: string | undefined;
    supplyFanControl?: UIPropertyOfSupplyFanControlType | undefined;
    returnFanControl?: UIPropertyOfReturnFanControlType | undefined;
    exhaustFanControl?: UIPropertyOfExhaustFanControlType | undefined;
    temperatureControl?: UIPropertyOfTemperatureControlType | undefined;
    dehumidificationControl?: UIPropertyOfDehumidificationControlType | undefined;
    economizerInitiation?: UIPropertyOfEconomizerInitiationType | undefined;
    minimumOutsideAirControl?: UIPropertyOfMinimumOutsideAirControlType | undefined;
    unoccupiedModeControl?: UIPropertyOfUnoccupiedModeControlType | undefined;
    unoccupiedWarmUp?: UIPropertyOfBoolean | undefined;
    unoccupiedCoolDown?: UIPropertyOfBoolean | undefined;
    heatWheelRotationDetection?: UIPropertyOfBoolean | undefined;
    demandControlVentilationCO2?: UIPropertyOfBoolean | undefined;
    dirtyFilterSwitches?: UIPropertyOfBoolean | undefined;
    filterPressureTransducers?: UIPropertyOfBoolean | undefined;
    condensateDrainPanOverflowSwitch?: UIPropertyOfBoolean | undefined;
    freezestat?: UIPropertyOfBoolean | undefined;
    highDuctStaticPressure?: UIPropertyOfBoolean | undefined;
    lowDuctStaticPressure?: UIPropertyOfBoolean | undefined;
    interfaceCard?: UIPropertyOfInterfaceCard | undefined;
    showInterfaceCard?: boolean;
}

export interface UIPropertyOfControlsInclusionType extends UIProperty {
    value?: ControlsInclusionType;
    choices?: IUIPropertyChoicesListOfControlsInclusionType | undefined;
}

export enum ControlsInclusionType {
    None = 0, 
    ProvidedByAndInstalledByInnovent = 1, 
    ProvidedByAndInstalledByOthers = 2, 
    RefrigerationProvidedByAndInstalledByInnovent = 3, 
}

export interface IUIPropertyChoicesListOfControlsInclusionType {
}

export interface UIPropertyOfDamperActuatorsInclusionType extends UIProperty {
    value?: DamperActuatorsInclusionType;
    choices?: IUIPropertyChoicesListOfDamperActuatorsInclusionType | undefined;
}

export enum DamperActuatorsInclusionType {
    ProvidedByInnoventAndInstalledByInnovent = 0, 
    ProvidedByOthersAndInstalledByOthers = 1, 
}

export interface IUIPropertyChoicesListOfDamperActuatorsInclusionType {
}

export interface UIPropertyOfSupplyFanControlType extends UIProperty {
    value?: SupplyFanControlType;
    choices?: IUIPropertyChoicesListOfSupplyFanControlType | undefined;
}

export enum SupplyFanControlType {
    None = 0, 
    ManualBalance = 1, 
    DuctStaticPressure = 2, 
    SupplyCfm = 3, 
    HardwiredSignal0to10VDC = 4, 
    SingleZone = 5, 
}

export interface IUIPropertyChoicesListOfSupplyFanControlType {
}

export interface UIPropertyOfReturnFanControlType extends UIProperty {
    value?: ReturnFanControlType;
    choices?: IUIPropertyChoicesListOfReturnFanControlType | undefined;
}

export enum ReturnFanControlType {
    None = 0, 
    SpaceStaticPressure = 1, 
    ManualBalance = 2, 
    DuctStaticPressure = 3, 
    ReturnCFM = 4, 
    HardwiredSignal0to10VDC = 5, 
}

export interface IUIPropertyChoicesListOfReturnFanControlType {
}

export interface UIPropertyOfExhaustFanControlType extends UIProperty {
    value?: ExhaustFanControlType;
    choices?: IUIPropertyChoicesListOfExhaustFanControlType | undefined;
}

export enum ExhaustFanControlType {
    None = 0, 
    ManualBalance = 1, 
    DuctStaticPressure = 2, 
    ExhaustCfm = 3, 
    PositiveSpaceStaticPressure = 4, 
    NegativeSpaceStaticPressure = 5, 
    HardwiredSignal0to10VDC = 6, 
    TrackSupplyFan = 7, 
}

export interface IUIPropertyChoicesListOfExhaustFanControlType {
}

export interface UIPropertyOfTemperatureControlType extends UIProperty {
    value?: TemperatureControlType;
    choices?: IUIPropertyChoicesListOfTemperatureControlType | undefined;
}

export enum TemperatureControlType {
    None = 0, 
    SupplyDischarge = 1, 
    ReturnReset = 2, 
    SpaceReset = 3, 
    OutsideAirReset = 4, 
}

export interface IUIPropertyChoicesListOfTemperatureControlType {
}

export interface UIPropertyOfDehumidificationControlType extends UIProperty {
    value?: DehumidificationControlType;
    choices?: IUIPropertyChoicesListOfDehumidificationControlType | undefined;
}

export enum DehumidificationControlType {
    None = 0, 
    ReturnDewPointGreaterThanDehumSetPoint = 1, 
    SpaceDewPointGreaterThanDehumSetPoint = 2, 
    OutsideDewPointGreaterThanDehumsetPoint = 3, 
    ReturnRelativeHumidityGreaterThanDehumSetPoint = 4, 
    SpaceRelativeHumidityGreaterThanDehumSetPoint = 5, 
    SpaceOrOaDewPointGreaterThanDehumSetPoint = 6, 
}

export interface IUIPropertyChoicesListOfDehumidificationControlType {
}

export interface UIPropertyOfEconomizerInitiationType extends UIProperty {
    value?: EconomizerInitiationType;
    choices?: IUIPropertyChoicesListOfEconomizerInitiationType | undefined;
}

export enum EconomizerInitiationType {
    None = 0, 
    OutsideDryBulbLessThanReturnDryBulb = 1, 
    OutsideDryBulbLessThanSpaceDryBulb = 2, 
    OutsideDryBulbLessThanDryBulbSetpoint = 3, 
    OutsideEnthalpyLessThanReturnEnthalpy = 4, 
    OutsideEnthalpyLessThanSpaceEnthalpy = 5, 
    OutsideEnthalpyLessThanEnthalpySetpoint = 6, 
    ReturnEnthalpyAndOutsideDryBulb = 7, 
    SpaceEnthalpyAndOutsideDryBulb = 8, 
    EnthalpySetPointAndOutsideDryBulb = 9, 
}

export interface IUIPropertyChoicesListOfEconomizerInitiationType {
}

export interface UIPropertyOfMinimumOutsideAirControlType extends UIProperty {
    value?: MinimumOutsideAirControlType;
    choices?: IUIPropertyChoicesListOfMinimumOutsideAirControlType | undefined;
}

export enum MinimumOutsideAirControlType {
    None = 0, 
    MinimumOutsideAirCfm = 1, 
    MinimumPercentOfDesignAirflow = 2, 
}

export interface IUIPropertyChoicesListOfMinimumOutsideAirControlType {
}

export interface UIPropertyOfUnoccupiedModeControlType extends UIProperty {
    value?: UnoccupiedModeControlType;
    choices?: IUIPropertyChoicesListOfUnoccupiedModeControlType | undefined;
}

export enum UnoccupiedModeControlType {
    None = 0, 
    UnitIsOff = 1, 
    NightSetbackWithSupplyFanStandby = 2, 
    NightSetbackWithSupplyFanOn = 3, 
}

export interface IUIPropertyChoicesListOfUnoccupiedModeControlType {
}

export interface UIPropertyOfInterfaceCard extends UIProperty {
    value?: InterfaceCard;
    choices?: IUIPropertyChoicesListOfInterfaceCard | undefined;
}

export enum InterfaceCard {
    None = 0, 
    BacnetMSTP = 1, 
    BacnetIP = 2, 
    LonworksFTT10A = 3, 
    ModbusRTUModeoverRS485 = 4, 
}

export interface IUIPropertyChoicesListOfInterfaceCard {
}

export interface ElectricalUI extends UIEntity {
    voltage?: string | undefined;
    sccr?: UIPropertyOfShortCircuitCurrentRatingType | undefined;
    disconnectFusing?: UIPropertyOfBoolean | undefined;
    disconnectFusingDisabled?: UIPropertyOfBoolean | undefined;
    phaseVoltageProtection?: UIPropertyOfBoolean | undefined;
    phaseVoltageProtectionDisabled?: boolean;
    fanVfdItems?: FanVfdItem[] | undefined;
    gfciQuantity?: UIPropertyOfInt32 | undefined;
    circuitPower?: UIPropertyOfSinglePhaseCircuitPower | undefined;
    lightInclusion?: UIPropertyOfLightInclusionLocation | undefined;
    vfdProvisionInstallation?: UIPropertyOfVFDProvisionInstallation | undefined;
    smokeDetectors?: UIPropertyOfSmokeDetectors | undefined;
    smokeDetectorInclusion?: UIPropertyOfSmokeDetectorInclusionType | undefined;
    smokeDetectorType?: UIPropertyOfSmokeDetectorType | undefined;
}

export interface UIPropertyOfShortCircuitCurrentRatingType extends UIProperty {
    value?: ShortCircuitCurrentRatingType;
    choices?: IUIPropertyChoicesListOfShortCircuitCurrentRatingType | undefined;
}

export enum ShortCircuitCurrentRatingType {
    None = 0, 
    FivekA = 1, 
    SixtyFivekA = 2, 
}

export interface IUIPropertyChoicesListOfShortCircuitCurrentRatingType {
}

export interface FanVfdItem extends UIEntity {
    showVfdSharingErrorMessage?: boolean;
    quantity?: UIPropertyOfFanArrayVfdSharing | undefined;
    allowMicrodrives?: UIPropertyOfBoolean | undefined;
    manualBypass?: UIPropertyOfBoolean | undefined;
    name?: UIPropertyOfString | undefined;
}

export interface UIPropertyOfFanArrayVfdSharing extends UIProperty {
    value?: FanArrayVfdSharing;
    choices?: IUIPropertyChoicesListOfFanArrayVfdSharing | undefined;
}

export enum FanArrayVfdSharing {
    OnePerFan = 1, 
    OnePerArray = 2, 
}

export interface IUIPropertyChoicesListOfFanArrayVfdSharing {
}

export interface UIPropertyOfSinglePhaseCircuitPower extends UIProperty {
    value?: SinglePhaseCircuitPower;
    choices?: IUIPropertyChoicesListOfSinglePhaseCircuitPower | undefined;
}

export enum SinglePhaseCircuitPower {
    NotApplicable = 0, 
    UnitTransformer = 1, 
    PowerByOthers = 2, 
}

export interface IUIPropertyChoicesListOfSinglePhaseCircuitPower {
}

export interface UIPropertyOfLightInclusionLocation extends UIProperty {
    value?: LightInclusionLocation;
    choices?: IUIPropertyChoicesListOfLightInclusionLocation | undefined;
}

export enum LightInclusionLocation {
    None = 0, 
    Fansections = 1, 
    FilterSections = 2, 
    FanAndFilterSections = 3, 
    AllAccessSections = 4, 
}

export interface IUIPropertyChoicesListOfLightInclusionLocation {
}

export interface UIPropertyOfVFDProvisionInstallation extends UIProperty {
    value?: VFDProvisionInstallation;
    choices?: IUIPropertyChoicesListOfVFDProvisionInstallation | undefined;
}

export enum VFDProvisionInstallation {
    ProvidedByAndInstalledByInnovent = 0, 
    ProvidedByAndInstalledByOthers = 1, 
}

export interface IUIPropertyChoicesListOfVFDProvisionInstallation {
}

export interface UIPropertyOfSmokeDetectors extends UIProperty {
    value?: SmokeDetectors;
    choices?: IUIPropertyChoicesListOfSmokeDetectors | undefined;
}

export enum SmokeDetectors {
    None = 0, 
    Supply = 1, 
    Return = 2, 
    SupplyAndReturn = 3, 
}

export interface IUIPropertyChoicesListOfSmokeDetectors {
}

export interface UIPropertyOfSmokeDetectorInclusionType extends UIProperty {
    value?: SmokeDetectorInclusionType;
    choices?: IUIPropertyChoicesListOfSmokeDetectorInclusionType | undefined;
}

export enum SmokeDetectorInclusionType {
    None = 0, 
    ProvidedByOthersAndInstalledByOthers = 1, 
    ProvidedByInnoventAndInstalledByInnovent = 2, 
    ProvidedByInnoventAndInstalledByOthers = 3, 
}

export interface IUIPropertyChoicesListOfSmokeDetectorInclusionType {
}

export interface UIPropertyOfSmokeDetectorType extends UIProperty {
    value?: SmokeDetectorType;
    choices?: IUIPropertyChoicesListOfSmokeDetectorType | undefined;
}

export enum SmokeDetectorType {
    None = 0, 
    PhotoElectric = 1, 
    Ionization = 2, 
}

export interface IUIPropertyChoicesListOfSmokeDetectorType {
}

export interface UnitCabinetUI extends UIEntity {
    exteriorMaterial?: UIPropertyOfExteriorMaterialType | undefined;
    exteriorMaterialPaintColor?: UIPropertyOfString | undefined;
    interiorMaterial?: UIPropertyOfInteriorMaterialType | undefined;
    mountingType?: UIPropertyOfMountingType | undefined;
    curbProvidedBy?: UIPropertyOfCurbProvidedBy | undefined;
    curbHeight?: UIPropertyOfInt32 | undefined;
    perforatedLiner?: UIPropertyOfPerforatedLinerType | undefined;
    floorConstruction?: UIPropertyOfFloorConstructionType | undefined;
    floorMaterial?: UIPropertyOfFloorMaterialType | undefined;
    floorDrains?: UIPropertyOfFloorDrainsType | undefined;
    shippingShrinkWrap?: UIPropertyOfBoolean | undefined;
    shippingShrinkWrapEnabled?: boolean;
    coolingOptionSelected?: boolean;
    sensiblePlateSelected?: boolean;
    humidifierManifoldSharesDrainPanWithCooling?: boolean;
    hasHumidifierManifold?: boolean;
    displayCurbProvidecBy?: boolean;
    displayCurbHeight?: boolean;
    sensiblePlateDrainPanMaterial?: UIPropertyOfDrainPanMaterialType | undefined;
    coolingCoilDrainPanMaterial?: UIPropertyOfDrainPanMaterialType | undefined;
    humidifierManifoldDrainPanMaterial?: UIPropertyOfDrainPanMaterialType | undefined;
    inwardSwinging?: UIPropertyOfInwardSwingingLocation | undefined;
    thermalBreak?: UIPropertyOfThermalBreakLocation | undefined;
    windowInclusion?: UIPropertyOfWindowInclusion | undefined;
    doorLengthWarning?: string | undefined;
    window?: UIPropertyOfWindowType | undefined;
    pressureReliefLatch?: UIPropertyOfPressureReliefLatchLocation | undefined;
    interiorHandles?: UIPropertyOfInteriorHandlesLocation | undefined;
    tieBack?: UIPropertyOfTieBackLocation | undefined;
    lock?: UIPropertyOfLockType | undefined;
    doorHandleInterlock?: UIPropertyOfDoorHandleInterlockLocation | undefined;
    testPort?: UIPropertyOfTestPortLocation | undefined;
}

export interface UIPropertyOfExteriorMaterialType extends UIProperty {
    value?: ExteriorMaterialType;
    choices?: IUIPropertyChoicesListOfExteriorMaterialType | undefined;
}

export enum ExteriorMaterialType {
    NotSet = 0, 
    HiproPolyPaintedSteel = 1, 
    CustomColorAirDriedSteel = 2, 
    GalvanizedSteel = 3, 
    Aluminum = 4, 
    StainlessSteel304 = 5, 
    StainlessSteel316 = 6, 
}

export interface IUIPropertyChoicesListOfExteriorMaterialType {
}

export interface UIPropertyOfInteriorMaterialType extends UIProperty {
    value?: InteriorMaterialType;
    choices?: IUIPropertyChoicesListOfInteriorMaterialType | undefined;
}

export enum InteriorMaterialType {
    NotSet = 0, 
    GalvanizedSteel = 1, 
    StainlessSteel304 = 2, 
    StainlessSteel316 = 3, 
    Aluminum = 4, 
}

export interface IUIPropertyChoicesListOfInteriorMaterialType {
}

export interface UIPropertyOfMountingType extends UIProperty {
    value?: MountingType;
    choices?: IUIPropertyChoicesListOfMountingType | undefined;
}

export enum MountingType {
    ConcretePad = 0, 
    StructuralSteelDunnage = 1, 
    RoofCurb = 2, 
}

export interface IUIPropertyChoicesListOfMountingType {
}

export interface UIPropertyOfCurbProvidedBy extends UIProperty {
    value?: CurbProvidedBy;
    choices?: IUIPropertyChoicesListOfCurbProvidedBy | undefined;
}

export enum CurbProvidedBy {
    ProvidedByInnovent = 0, 
    ProvidedByOthers = 1, 
}

export interface IUIPropertyChoicesListOfCurbProvidedBy {
}

export interface UIPropertyOfPerforatedLinerType extends UIProperty {
    value?: PerforatedLinerType;
    choices?: IUIPropertyChoicesListOfPerforatedLinerType | undefined;
}

export enum PerforatedLinerType {
    None = 0, 
    FanSections = 1, 
    EntireUnit = 2, 
}

export interface IUIPropertyChoicesListOfPerforatedLinerType {
}

export interface UIPropertyOfFloorConstructionType extends UIProperty {
    value?: FloorConstructionType;
    choices?: IUIPropertyChoicesListOfFloorConstructionType | undefined;
}

export enum FloorConstructionType {
    NotSet = 0, 
    Paneled = 1, 
    FlatWelded = 2, 
    DroppedWelded = 3, 
}

export interface IUIPropertyChoicesListOfFloorConstructionType {
}

export interface UIPropertyOfFloorMaterialType extends UIProperty {
    value?: FloorMaterialType;
    choices?: IUIPropertyChoicesListOfFloorMaterialType | undefined;
}

export enum FloorMaterialType {
    NotSet = 0, 
    GalvanizedSteel = 1, 
    StainlessSteel304 = 2, 
    StainlessSteel316 = 3, 
    EpoxyCoatedSteelTreadplate = 4, 
    FlatAluminum = 5, 
    AluminumTreadplate = 6, 
    CoatedSteel = 7, 
}

export interface IUIPropertyChoicesListOfFloorMaterialType {
}

export interface UIPropertyOfFloorDrainsType extends UIProperty {
    value?: FloorDrainsType;
    choices?: IUIPropertyChoicesListOfFloorDrainsType | undefined;
}

export enum FloorDrainsType {
    None = 0, 
    InletAndMixingBoxSections = 1, 
    OutletSections = 2, 
    BothInletAndOutletSections = 3, 
    AllSections = 4, 
}

export interface IUIPropertyChoicesListOfFloorDrainsType {
}

export interface UIPropertyOfDrainPanMaterialType extends UIProperty {
    value?: DrainPanMaterialType;
    choices?: IUIPropertyChoicesListOfDrainPanMaterialType | undefined;
}

export enum DrainPanMaterialType {
    None = 0, 
    StainlessSteel201 = 1, 
    StainlessSteel304 = 2, 
    StainlessSteel316 = 3, 
    Aluminum = 4, 
}

export interface IUIPropertyChoicesListOfDrainPanMaterialType {
}

export interface UIPropertyOfInwardSwingingLocation extends UIProperty {
    value?: InwardSwingingLocation;
    choices?: IUIPropertyChoicesListOfInwardSwingingLocation | undefined;
}

export enum InwardSwingingLocation {
    None = 0, 
    DoorsOpeningWithPressure = 1, 
    AllDoors = 2, 
}

export interface IUIPropertyChoicesListOfInwardSwingingLocation {
}

export interface UIPropertyOfThermalBreakLocation extends UIProperty {
    value?: ThermalBreakLocation;
    choices?: IUIPropertyChoicesListOfThermalBreakLocation | undefined;
}

export enum ThermalBreakLocation {
    None = 0, 
    DownstreamOfCoolingComponents = 1, 
    AllDoors = 2, 
}

export interface IUIPropertyChoicesListOfThermalBreakLocation {
}

export interface UIPropertyOfWindowInclusion extends UIProperty {
    value?: WindowInclusion;
    choices?: IUIPropertyChoicesListOfWindowInclusion | undefined;
}

export enum WindowInclusion {
    None = 0, 
    AllDoors = 1, 
    FanSectionsOnly = 2, 
}

export interface IUIPropertyChoicesListOfWindowInclusion {
}

export interface UIPropertyOfWindowType extends UIProperty {
    value?: WindowType;
    choices?: IUIPropertyChoicesListOfWindowType | undefined;
}

export enum WindowType {
    None = 0, 
    SinglePaneWireglass12by12 = 1, 
    DoublePaneWireglass12by12 = 2, 
    SinglePanePlexiglass12by12 = 3, 
    DoublePanePlexiglass12by12 = 4, 
}

export interface IUIPropertyChoicesListOfWindowType {
}

export interface UIPropertyOfPressureReliefLatchLocation extends UIProperty {
    value?: PressureReliefLatchLocation;
    choices?: IUIPropertyChoicesListOfPressureReliefLatchLocation | undefined;
}

export enum PressureReliefLatchLocation {
    None = 0, 
    DoorsOpeningWithPressure = 1, 
}

export interface IUIPropertyChoicesListOfPressureReliefLatchLocation {
}

export interface UIPropertyOfInteriorHandlesLocation extends UIProperty {
    value?: InteriorHandlesLocation;
    choices?: IUIPropertyChoicesListOfInteriorHandlesLocation | undefined;
}

export enum InteriorHandlesLocation {
    None = 0, 
    AllDoors = 1, 
}

export interface IUIPropertyChoicesListOfInteriorHandlesLocation {
}

export interface UIPropertyOfTieBackLocation extends UIProperty {
    value?: TieBackLocation;
    choices?: IUIPropertyChoicesListOfTieBackLocation | undefined;
}

export enum TieBackLocation {
    None = 0, 
    AllDoors = 1, 
}

export interface IUIPropertyChoicesListOfTieBackLocation {
}

export interface UIPropertyOfLockType extends UIProperty {
    value?: LockType;
    choices?: IUIPropertyChoicesListOfLockType | undefined;
}

export enum LockType {
    NotSet = 0, 
    Tool = 1, 
    Key = 2, 
    Pad = 3, 
}

export interface IUIPropertyChoicesListOfLockType {
}

export interface UIPropertyOfDoorHandleInterlockLocation extends UIProperty {
    value?: DoorHandleInterlockLocation;
    choices?: IUIPropertyChoicesListOfDoorHandleInterlockLocation | undefined;
}

export enum DoorHandleInterlockLocation {
    None = 0, 
    AllDoors = 1, 
}

export interface IUIPropertyChoicesListOfDoorHandleInterlockLocation {
}

export interface UIPropertyOfTestPortLocation extends UIProperty {
    value?: TestPortLocation;
    choices?: IUIPropertyChoicesListOfTestPortLocation | undefined;
}

export enum TestPortLocation {
    None = 0, 
    AllDoors = 1, 
}

export interface IUIPropertyChoicesListOfTestPortLocation {
}

export interface StandardResponse4 {
    hasError?: boolean;
    errorMessage?: string | undefined;
}

export interface ConfigInputsUIResponse extends StandardResponse4 {
    unitBasicDetails?: UnitBasicDetails | undefined;
    dropdownOptions?: ConfigInputsOptionsDTO | undefined;
    validationErrors?: ClientError[] | undefined;
}

export interface UnitBasicDetails {
    unitBasicDetailsDTO?: UnitBasicDetailsDTO | undefined;
    editedFields?: string[] | undefined;
    unitBasicDetailsDisplayFields?: UnitBasicDetailsDisplayFields | undefined;
}

export interface StandardClientDTO {
    userId?: string | undefined;
    projectId?: number;
    unitId?: number;
    updatedFieldName?: string | undefined;
}

export interface UnitBasicDetailsDTO extends StandardClientDTO {
    unitTag?: string | undefined;
    unitQuantity?: number | undefined;
    unitType?: number | undefined;
    unitLocationType?: number | undefined;
    airflowArrangementType?: number | undefined;
    airTunnelOrientationType?: number | undefined;
    returnAirDirectionType?: number | undefined;
    supplyTunnelLocationType?: number | undefined;
    energyRecoveryDeviceType?: number | undefined;
    outsideAirAltitudeOnlyAcfm?: number | undefined;
    outsideAirAltitudeOnlyAcfmUserValue?: number | undefined;
    supplyAirAltitudeOnlyAcfm?: number | undefined;
    supplyAirAltitudeOnlyAcfmUserValue?: number | undefined;
    returnAirAltitudeOnlyAcfm?: number | undefined;
    exhaustAirAltitudeOnlyAcfm?: number | undefined;
    exhaustAirAltitudeOnlyAcfmUserValue?: number | undefined;
    coolingType?: number | undefined;
    heatingType?: number | undefined;
    preHeatType?: number | undefined;
    coolHeatSequenceType?: number | undefined;
    outsideAirPrefilterType?: number | undefined;
    outsideAirHighEfficiencyFilterType?: number | undefined;
    supplyAirFinalFilterType?: number | undefined;
    returnAirFilterType?: number | undefined;
    soundAttenuatorType?: number | undefined;
    humidifierManifoldType?: number | undefined;
    airHandlerType?: number | undefined;
    outsideAirInlet?: number | undefined;
    supplyAirOutlet?: number | undefined;
    returnAirInlet?: number | undefined;
    exhaustAirOutlet?: number | undefined;
    outsideAirInletLocation?: number | undefined;
    supplyAirOutletLocation?: number | undefined;
    returnAirInletLocation?: number | undefined;
    exhaustAirOutletLocation?: number | undefined;
    elevation?: number | undefined;
    outsideSummerDryBulb?: number | undefined;
    outsideSummerWetBulb?: number | undefined;
    outsideWinterDryBulb?: number | undefined;
    supplyEsp?: number | undefined;
    returnEsp?: number | undefined;
    unitElectricalVoltage?: number | undefined;
    returnSummerDryBulb?: number | undefined;
    returnSummerRelativeHumidity?: number | undefined;
    returnWinterDryBulb?: number | undefined;
    returnWinterRelativeHumidity?: number | undefined;
    coolingOffCoilDryBulb?: number | undefined;
    reheatTemp?: number | undefined;
    preheatDryBulb?: number | undefined;
    heatingTemp?: number | undefined;
    airflowSystem?: number | undefined;
    coilAndFilterFpmLimit?: number | undefined;
    casingWallThickness?: number | undefined;
    casingDimensionLimitType?: number | undefined;
    casingHeightOrWidthLimit?: number | undefined;
}

export interface UnitBasicDetailsDisplayFields {
    showEnergyRecoveryDevice?: boolean | undefined;
    showSupplyAndReturnAir?: boolean | undefined;
    showCoolHeatSequence?: boolean | undefined;
    showUnitLayoutInputs?: boolean | undefined;
    showReheatTemp?: boolean | undefined;
    showHeatingDryBulbTemp?: boolean | undefined;
    showCoolingDryBulbTemp?: boolean | undefined;
    showPreheatDryBulbTemp?: boolean | undefined;
    showWinterDryBulbWarning?: boolean | undefined;
    showCfmLimitWarning?: boolean | undefined;
    showDxSplitWarning?: boolean | undefined;
    showDxSplitHGRWarning?: boolean | undefined;
    showAirHandlerType?: boolean | undefined;
    showReturnAirFilter?: boolean | undefined;
    showReturnAirInlet?: boolean | undefined;
    showExhaustAirOutlet?: boolean | undefined;
    showExhaustAir?: boolean | undefined;
    showAirflowArrangement?: boolean | undefined;
    coolHeatSequenceDisabled?: boolean | undefined;
    returnAirDirectionDisabled?: boolean | undefined;
    casingDimensionLimitDisabled?: boolean | undefined;
    outsideAndExhaustOpeningDisabled?: boolean | undefined;
    unoccupiedModeRequiresRecircDamper?: boolean | undefined;
    airPrefilterLabel?: string | undefined;
    highEfficiencyFilterLabel?: string | undefined;
}

export interface ConfigInputsOptionsDTO {
    unitTypeOptions?: DropdownOptionDTO[] | undefined;
    energyRecoveryDeviceOptions?: DropdownOptionDTO[] | undefined;
    unitLocationOptions?: DropdownOptionDTO[] | undefined;
    airflowArrangementOptions?: DropdownOptionDTO[] | undefined;
    airTunnelOrientationOptions?: DropdownOptionDTO[] | undefined;
    returnAirDirectionOptions?: DropdownOptionDTO[] | undefined;
    supplyTunnelLocationOptions?: DropdownOptionDTO[] | undefined;
    coolingOptions?: DropdownOptionDTO[] | undefined;
    heatingOptions?: DropdownOptionDTO[] | undefined;
    coolHeatSequenceOptions?: DropdownOptionDTO[] | undefined;
    preHeatOptions?: DropdownOptionDTO[] | undefined;
    outsideAirPrefilterOptions?: DropdownOptionDTO[] | undefined;
    outsideAirHighEfficiencyFilterOptions?: DropdownOptionDTO[] | undefined;
    supplyAirFinalFilterOptions?: DropdownOptionDTO[] | undefined;
    returnAirFilterOptions?: DropdownOptionDTO[] | undefined;
    soundAttenuatorOptions?: DropdownOptionDTO[] | undefined;
    humidifierManifoldOptions?: DropdownOptionDTO[] | undefined;
    airHandlerOptions?: DropdownOptionDTO[] | undefined;
}

export interface DropdownOptionDTO {
    numericValue?: number | undefined;
    textValue?: string | undefined;
    displayValue?: string | undefined;
}

export interface ClientError {
    fieldName?: string | undefined;
    errorMessage?: string | undefined;
    suppressErrorInUi?: boolean;
}

export interface SupplementalDetailsUIResponse extends StandardResponse4 {
    supplementalDetails?: UnitSupplementalDetails | undefined;
    dropdownOptions?: SupplementaryDetailsOptionsDTO | undefined;
}

export interface UnitSupplementalDetails {
    supplementalDetailsDTO?: SupplementalDetailsDTO | undefined;
    unitSupplementalDetailsDisplayFields?: UnitSupplementalDetailsDisplayFields | undefined;
}

export interface SupplementalDetailsDTO extends StandardClientDTO {
    unitPartsWarranty?: number | undefined;
    compressorWarranty?: number | undefined;
    plateHXWarranty?: number | undefined;
    idfWarranty?: number | undefined;
}

export interface UnitSupplementalDetailsDisplayFields {
    showIDFWarranty?: boolean;
    showCompressorWarranty?: boolean;
    showPlateHXWarranty?: boolean;
}

export interface SupplementaryDetailsOptionsDTO {
    unitPartsWarrantyOptions?: DropdownOptionDTO[] | undefined;
    compressorWarrantyOptions?: DropdownOptionDTO[] | undefined;
    plateHXWarrantyOptions?: DropdownOptionDTO[] | undefined;
    idfWarrantyOptions?: DropdownOptionDTO[] | undefined;
}

export interface InletOutletUIResponse extends StandardResponse4 {
    unitBasicDetails?: UnitBasicDetails | undefined;
    dropdownOptions?: InletOutletOptionsDTO | undefined;
    validationErrors?: ClientError[] | undefined;
}

export interface InletOutletOptionsDTO {
    inletOutletTypes?: DropdownOptionDTO[] | undefined;
    inletOutletLocations?: DropdownOptionDTO[] | undefined;
    outsideAirInletOptions?: DropdownOptionDTO[] | undefined;
    outsideAirInletLocationOptions?: DropdownOptionDTO[] | undefined;
    supplyAirOutletLocationOptions?: DropdownOptionDTO[] | undefined;
    returnAirInletLocationOptions?: DropdownOptionDTO[] | undefined;
    exhaustAirOutletOptions?: DropdownOptionDTO[] | undefined;
    exhaustAirOutletLocationOptions?: DropdownOptionDTO[] | undefined;
}

export interface TempsAndSystemUIResponse extends StandardResponse4 {
    unitBasicDetails?: UnitBasicDetails | undefined;
    dropdownOptions?: TempsAndSystemOptionsDTO | undefined;
    validationErrors?: ClientError[] | undefined;
}

export interface TempsAndSystemOptionsDTO {
    unitVoltageOptions?: DropdownOptionDTO[] | undefined;
    airVolumeControlOptions?: DropdownOptionDTO[] | undefined;
}

export interface SchematicResponse extends StandardResponse2 {
    schematicSvg?: string | undefined;
}

export interface FieldUpdateRequest {
    projectId?: number;
    unitId?: number;
    fieldName?: string | undefined;
    newValue?: string | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number; 
    response: string; 
    headers: { [key: string]: any; };
    result: any; 

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if(result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}